const compatModules = {};import * as Mod1 from "./discourse/adapters/chat-message";
compatModules["discourse/adapters/chat-message"] = Mod1;

export * as discourse$adapters$chat__message$$__module from "./discourse/adapters/chat-message";
export {
default as discourse$adapters$chat__message$$default
} from "./discourse/adapters/chat-message";
import * as Mod2 from "./discourse/admin-chat-route-map";
compatModules["discourse/admin-chat-route-map"] = Mod2;

export * as discourse$admin__chat__route__map$$__module from "./discourse/admin-chat-route-map";
export {
default as discourse$admin__chat__route__map$$default
} from "./discourse/admin-chat-route-map";
import * as Mod3 from "./discourse/chat-route-map";
compatModules["discourse/chat-route-map"] = Mod3;

export * as discourse$chat__route__map$$__module from "./discourse/chat-route-map";
export {
default as discourse$chat__route__map$$default
} from "./discourse/chat-route-map";
import * as Mod4 from "./discourse/components/browse-channels";
compatModules["discourse/components/browse-channels"] = Mod4;

export * as discourse$components$browse__channels$$__module from "./discourse/components/browse-channels";
export {
default as discourse$components$browse__channels$$default
} from "./discourse/components/browse-channels";
import * as Mod5 from "./discourse/components/channel-icon/index";
compatModules["discourse/components/channel-icon/index"] = Mod5;

export * as discourse$components$channel__icon$index$$__module from "./discourse/components/channel-icon/index";
export {
default as discourse$components$channel__icon$index$$default,
default as discourse$components$channel__icon$$default
} from "./discourse/components/channel-icon/index";
import * as Mod6 from "./discourse/components/channel-name/index";
compatModules["discourse/components/channel-name/index"] = Mod6;

export * as discourse$components$channel__name$index$$__module from "./discourse/components/channel-name/index";
export {
default as discourse$components$channel__name$index$$default,
default as discourse$components$channel__name$$default
} from "./discourse/components/channel-name/index";
import * as Mod7 from "./discourse/components/channel-title/index";
compatModules["discourse/components/channel-title/index"] = Mod7;

export * as discourse$components$channel__title$index$$__module from "./discourse/components/channel-title/index";
export {
default as discourse$components$channel__title$index$$default,
default as discourse$components$channel__title$$default
} from "./discourse/components/channel-title/index";
import * as Mod8 from "./discourse/components/channels-list-direct";
compatModules["discourse/components/channels-list-direct"] = Mod8;

export * as discourse$components$channels__list__direct$$__module from "./discourse/components/channels-list-direct";
export {
default as discourse$components$channels__list__direct$$default
} from "./discourse/components/channels-list-direct";
import * as Mod9 from "./discourse/components/channels-list-public";
compatModules["discourse/components/channels-list-public"] = Mod9;

export * as discourse$components$channels__list__public$$__module from "./discourse/components/channels-list-public";
export {
default as discourse$components$channels__list__public$$default
} from "./discourse/components/channels-list-public";
import * as Mod10 from "./discourse/components/channels-list-starred";
compatModules["discourse/components/channels-list-starred"] = Mod10;

export * as discourse$components$channels__list__starred$$__module from "./discourse/components/channels-list-starred";
export {
default as discourse$components$channels__list__starred$$default
} from "./discourse/components/channels-list-starred";
import * as Mod11 from "./discourse/components/channels-list";
compatModules["discourse/components/channels-list"] = Mod11;

export * as discourse$components$channels__list$$__module from "./discourse/components/channels-list";
export {
default as discourse$components$channels__list$$default
} from "./discourse/components/channels-list";
import * as Mod12 from "./discourse/components/chat-channel-archive-status";
compatModules["discourse/components/chat-channel-archive-status"] = Mod12;

export * as discourse$components$chat__channel__archive__status$$__module from "./discourse/components/chat-channel-archive-status";
export {
default as discourse$components$chat__channel__archive__status$$default
} from "./discourse/components/chat-channel-archive-status";
import * as Mod13 from "./discourse/components/chat-channel-card";
compatModules["discourse/components/chat-channel-card"] = Mod13;

export * as discourse$components$chat__channel__card$$__module from "./discourse/components/chat-channel-card";
export {
default as discourse$components$chat__channel__card$$default
} from "./discourse/components/chat-channel-card";
import * as Mod14 from "./discourse/components/chat-channel-chooser-header";
compatModules["discourse/components/chat-channel-chooser-header"] = Mod14;

export * as discourse$components$chat__channel__chooser__header$$__module from "./discourse/components/chat-channel-chooser-header";
export {
default as discourse$components$chat__channel__chooser__header$$default
} from "./discourse/components/chat-channel-chooser-header";
import * as Mod15 from "./discourse/components/chat-channel-chooser-row";
compatModules["discourse/components/chat-channel-chooser-row"] = Mod15;

export * as discourse$components$chat__channel__chooser__row$$__module from "./discourse/components/chat-channel-chooser-row";
export {
default as discourse$components$chat__channel__chooser__row$$default
} from "./discourse/components/chat-channel-chooser-row";
import * as Mod16 from "./discourse/components/chat-channel-chooser";
compatModules["discourse/components/chat-channel-chooser"] = Mod16;

export * as discourse$components$chat__channel__chooser$$__module from "./discourse/components/chat-channel-chooser";
export {
default as discourse$components$chat__channel__chooser$$default
} from "./discourse/components/chat-channel-chooser";
import * as Mod17 from "./discourse/components/chat-channel-filter";
compatModules["discourse/components/chat-channel-filter"] = Mod17;

export * as discourse$components$chat__channel__filter$$__module from "./discourse/components/chat-channel-filter";
export {
default as discourse$components$chat__channel__filter$$default
} from "./discourse/components/chat-channel-filter";
import * as Mod18 from "./discourse/components/chat-channel-leave-btn";
compatModules["discourse/components/chat-channel-leave-btn"] = Mod18;

export * as discourse$components$chat__channel__leave__btn$$__module from "./discourse/components/chat-channel-leave-btn";
export {
default as discourse$components$chat__channel__leave__btn$$default
} from "./discourse/components/chat-channel-leave-btn";
import * as Mod19 from "./discourse/components/chat-channel-metadata";
compatModules["discourse/components/chat-channel-metadata"] = Mod19;

export * as discourse$components$chat__channel__metadata$$__module from "./discourse/components/chat-channel-metadata";
export {
default as discourse$components$chat__channel__metadata$$default
} from "./discourse/components/chat-channel-metadata";
import * as Mod20 from "./discourse/components/chat-channel-preview-card";
compatModules["discourse/components/chat-channel-preview-card"] = Mod20;

export * as discourse$components$chat__channel__preview__card$$__module from "./discourse/components/chat-channel-preview-card";
export {
default as discourse$components$chat__channel__preview__card$$default
} from "./discourse/components/chat-channel-preview-card";
import * as Mod21 from "./discourse/components/chat-channel-row";
compatModules["discourse/components/chat-channel-row"] = Mod21;

export * as discourse$components$chat__channel__row$$__module from "./discourse/components/chat-channel-row";
export {
default as discourse$components$chat__channel__row$$default
} from "./discourse/components/chat-channel-row";
import * as Mod22 from "./discourse/components/chat-channel-sidebar-context-menu";
compatModules["discourse/components/chat-channel-sidebar-context-menu"] = Mod22;

export * as discourse$components$chat__channel__sidebar__context__menu$$__module from "./discourse/components/chat-channel-sidebar-context-menu";
export {
default as discourse$components$chat__channel__sidebar__context__menu$$default
} from "./discourse/components/chat-channel-sidebar-context-menu";
import * as Mod23 from "./discourse/components/chat-channel-sidebar-context-notification-submenu";
compatModules["discourse/components/chat-channel-sidebar-context-notification-submenu"] = Mod23;

export * as discourse$components$chat__channel__sidebar__context__notification__submenu$$__module from "./discourse/components/chat-channel-sidebar-context-notification-submenu";
export {
default as discourse$components$chat__channel__sidebar__context__notification__submenu$$default
} from "./discourse/components/chat-channel-sidebar-context-notification-submenu";
import * as Mod24 from "./discourse/components/chat-channel-status";
compatModules["discourse/components/chat-channel-status"] = Mod24;

export * as discourse$components$chat__channel__status$$__module from "./discourse/components/chat-channel-status";
export {
default as discourse$components$chat__channel__status$$default
} from "./discourse/components/chat-channel-status";
import * as Mod25 from "./discourse/components/chat-channel-title";
compatModules["discourse/components/chat-channel-title"] = Mod25;

export * as discourse$components$chat__channel__title$$__module from "./discourse/components/chat-channel-title";
export {
default as discourse$components$chat__channel__title$$default
} from "./discourse/components/chat-channel-title";
import * as Mod26 from "./discourse/components/chat-channel-unread-indicator";
compatModules["discourse/components/chat-channel-unread-indicator"] = Mod26;

export * as discourse$components$chat__channel__unread__indicator$$__module from "./discourse/components/chat-channel-unread-indicator";
export {
default as discourse$components$chat__channel__unread__indicator$$default
} from "./discourse/components/chat-channel-unread-indicator";
import * as Mod27 from "./discourse/components/chat-channel";
compatModules["discourse/components/chat-channel"] = Mod27;

export * as discourse$components$chat__channel$$__module from "./discourse/components/chat-channel";
export {
default as discourse$components$chat__channel$$default
} from "./discourse/components/chat-channel";
import * as Mod28 from "./discourse/components/chat-composer-dropdown";
compatModules["discourse/components/chat-composer-dropdown"] = Mod28;

export * as discourse$components$chat__composer__dropdown$$__module from "./discourse/components/chat-composer-dropdown";
export {
default as discourse$components$chat__composer__dropdown$$default
} from "./discourse/components/chat-composer-dropdown";
import * as Mod29 from "./discourse/components/chat-composer-message-details";
compatModules["discourse/components/chat-composer-message-details"] = Mod29;

export * as discourse$components$chat__composer__message__details$$__module from "./discourse/components/chat-composer-message-details";
export {
default as discourse$components$chat__composer__message__details$$default
} from "./discourse/components/chat-composer-message-details";
import * as Mod30 from "./discourse/components/chat-composer-upload";
compatModules["discourse/components/chat-composer-upload"] = Mod30;

export * as discourse$components$chat__composer__upload$$__module from "./discourse/components/chat-composer-upload";
export {
default as discourse$components$chat__composer__upload$$default
} from "./discourse/components/chat-composer-upload";
import * as Mod31 from "./discourse/components/chat-composer-uploads";
compatModules["discourse/components/chat-composer-uploads"] = Mod31;

export * as discourse$components$chat__composer__uploads$$__module from "./discourse/components/chat-composer-uploads";
export {
default as discourse$components$chat__composer__uploads$$default
} from "./discourse/components/chat-composer-uploads";
import * as Mod32 from "./discourse/components/chat-composer";
compatModules["discourse/components/chat-composer"] = Mod32;

export * as discourse$components$chat__composer$$__module from "./discourse/components/chat-composer";
export {
default as discourse$components$chat__composer$$default
} from "./discourse/components/chat-composer";
import * as Mod33 from "./discourse/components/chat-drawer";
compatModules["discourse/components/chat-drawer"] = Mod33;

export * as discourse$components$chat__drawer$$__module from "./discourse/components/chat-drawer";
export {
default as discourse$components$chat__drawer$$default
} from "./discourse/components/chat-drawer";
import * as Mod34 from "./discourse/components/chat-emoji-avatar";
compatModules["discourse/components/chat-emoji-avatar"] = Mod34;

export * as discourse$components$chat__emoji__avatar$$__module from "./discourse/components/chat-emoji-avatar";
export {
default as discourse$components$chat__emoji__avatar$$default
} from "./discourse/components/chat-emoji-avatar";
import * as Mod35 from "./discourse/components/chat-footer";
compatModules["discourse/components/chat-footer"] = Mod35;

export * as discourse$components$chat__footer$$__module from "./discourse/components/chat-footer";
export {
default as discourse$components$chat__footer$$default
} from "./discourse/components/chat-footer";
import * as Mod36 from "./discourse/components/chat-header";
compatModules["discourse/components/chat-header"] = Mod36;

export * as discourse$components$chat__header$$__module from "./discourse/components/chat-header";
export {
default as discourse$components$chat__header$$default
} from "./discourse/components/chat-header";
import * as Mod37 from "./discourse/components/chat-mention-warnings";
compatModules["discourse/components/chat-mention-warnings"] = Mod37;

export * as discourse$components$chat__mention__warnings$$__module from "./discourse/components/chat-mention-warnings";
export {
default as discourse$components$chat__mention__warnings$$default
} from "./discourse/components/chat-mention-warnings";
import * as Mod38 from "./discourse/components/chat-message-actions-desktop";
compatModules["discourse/components/chat-message-actions-desktop"] = Mod38;

export * as discourse$components$chat__message__actions__desktop$$__module from "./discourse/components/chat-message-actions-desktop";
export {
default as discourse$components$chat__message__actions__desktop$$default
} from "./discourse/components/chat-message-actions-desktop";
import * as Mod39 from "./discourse/components/chat-message-actions-mobile";
compatModules["discourse/components/chat-message-actions-mobile"] = Mod39;

export * as discourse$components$chat__message__actions__mobile$$__module from "./discourse/components/chat-message-actions-mobile";
export {
default as discourse$components$chat__message__actions__mobile$$default
} from "./discourse/components/chat-message-actions-mobile";
import * as Mod40 from "./discourse/components/chat-message-collapser";
compatModules["discourse/components/chat-message-collapser"] = Mod40;

export * as discourse$components$chat__message__collapser$$__module from "./discourse/components/chat-message-collapser";
export {
default as discourse$components$chat__message__collapser$$default,
isCollapsible as discourse$components$chat__message__collapser$$isCollapsible
} from "./discourse/components/chat-message-collapser";
import * as Mod41 from "./discourse/components/chat-message-in-reply-to-indicator";
compatModules["discourse/components/chat-message-in-reply-to-indicator"] = Mod41;

export * as discourse$components$chat__message__in__reply__to__indicator$$__module from "./discourse/components/chat-message-in-reply-to-indicator";
export {
default as discourse$components$chat__message__in__reply__to__indicator$$default
} from "./discourse/components/chat-message-in-reply-to-indicator";
import * as Mod42 from "./discourse/components/chat-message-reaction";
compatModules["discourse/components/chat-message-reaction"] = Mod42;

export * as discourse$components$chat__message__reaction$$__module from "./discourse/components/chat-message-reaction";
export {
default as discourse$components$chat__message__reaction$$default
} from "./discourse/components/chat-message-reaction";
import * as Mod43 from "./discourse/components/chat-message-reactions-users";
compatModules["discourse/components/chat-message-reactions-users"] = Mod43;

export * as discourse$components$chat__message__reactions__users$$__module from "./discourse/components/chat-message-reactions-users";
export {
default as discourse$components$chat__message__reactions__users$$default
} from "./discourse/components/chat-message-reactions-users";
import * as Mod44 from "./discourse/components/chat-message-separator";
compatModules["discourse/components/chat-message-separator"] = Mod44;

export * as discourse$components$chat__message__separator$$__module from "./discourse/components/chat-message-separator";
export {
default as discourse$components$chat__message__separator$$default
} from "./discourse/components/chat-message-separator";
import * as Mod45 from "./discourse/components/chat-message-text";
compatModules["discourse/components/chat-message-text"] = Mod45;

export * as discourse$components$chat__message__text$$__module from "./discourse/components/chat-message-text";
export {
default as discourse$components$chat__message__text$$default
} from "./discourse/components/chat-message-text";
import * as Mod46 from "./discourse/components/chat-message-thread-indicator";
compatModules["discourse/components/chat-message-thread-indicator"] = Mod46;

export * as discourse$components$chat__message__thread__indicator$$__module from "./discourse/components/chat-message-thread-indicator";
export {
default as discourse$components$chat__message__thread__indicator$$default
} from "./discourse/components/chat-message-thread-indicator";
import * as Mod47 from "./discourse/components/chat-message";
compatModules["discourse/components/chat-message"] = Mod47;

export * as discourse$components$chat__message$$__module from "./discourse/components/chat-message";
export {
addChatMessageDecorator as discourse$components$chat__message$$addChatMessageDecorator,
resetChatMessageDecorators as discourse$components$chat__message$$resetChatMessageDecorators,
MENTION_KEYWORDS as discourse$components$chat__message$$MENTION_KEYWORDS,
MESSAGE_CONTEXT_THREAD as discourse$components$chat__message$$MESSAGE_CONTEXT_THREAD,
default as discourse$components$chat__message$$default
} from "./discourse/components/chat-message";
import * as Mod48 from "./discourse/components/chat-message/blocks/actions";
compatModules["discourse/components/chat-message/blocks/actions"] = Mod48;

export * as discourse$components$chat__message$blocks$actions$$__module from "./discourse/components/chat-message/blocks/actions";
export {
default as discourse$components$chat__message$blocks$actions$$default
} from "./discourse/components/chat-message/blocks/actions";
import * as Mod49 from "./discourse/components/chat-message/blocks/block";
compatModules["discourse/components/chat-message/blocks/block"] = Mod49;

export * as discourse$components$chat__message$blocks$block$$__module from "./discourse/components/chat-message/blocks/block";
export {
default as discourse$components$chat__message$blocks$block$$default
} from "./discourse/components/chat-message/blocks/block";
import * as Mod50 from "./discourse/components/chat-message/blocks/element";
compatModules["discourse/components/chat-message/blocks/element"] = Mod50;

export * as discourse$components$chat__message$blocks$element$$__module from "./discourse/components/chat-message/blocks/element";
export {
default as discourse$components$chat__message$blocks$element$$default
} from "./discourse/components/chat-message/blocks/element";
import * as Mod51 from "./discourse/components/chat-message/blocks/elements/button";
compatModules["discourse/components/chat-message/blocks/elements/button"] = Mod51;

export * as discourse$components$chat__message$blocks$elements$button$$__module from "./discourse/components/chat-message/blocks/elements/button";
export {
default as discourse$components$chat__message$blocks$elements$button$$default
} from "./discourse/components/chat-message/blocks/elements/button";
import * as Mod52 from "./discourse/components/chat-message/blocks/elements/category";
compatModules["discourse/components/chat-message/blocks/elements/category"] = Mod52;

export * as discourse$components$chat__message$blocks$elements$category$$__module from "./discourse/components/chat-message/blocks/elements/category";
export {
default as discourse$components$chat__message$blocks$elements$category$$default
} from "./discourse/components/chat-message/blocks/elements/category";
import * as Mod53 from "./discourse/components/chat-message/blocks/index";
compatModules["discourse/components/chat-message/blocks/index"] = Mod53;

export * as discourse$components$chat__message$blocks$index$$__module from "./discourse/components/chat-message/blocks/index";
export {
default as discourse$components$chat__message$blocks$index$$default,
default as discourse$components$chat__message$blocks$$default
} from "./discourse/components/chat-message/blocks/index";
import * as Mod54 from "./discourse/components/chat-message/blocks/informative";
compatModules["discourse/components/chat-message/blocks/informative"] = Mod54;

export * as discourse$components$chat__message$blocks$informative$$__module from "./discourse/components/chat-message/blocks/informative";
export {
default as discourse$components$chat__message$blocks$informative$$default
} from "./discourse/components/chat-message/blocks/informative";
import * as Mod55 from "./discourse/components/chat-messages-container";
compatModules["discourse/components/chat-messages-container"] = Mod55;

export * as discourse$components$chat__messages__container$$__module from "./discourse/components/chat-messages-container";
export {
default as discourse$components$chat__messages__container$$default
} from "./discourse/components/chat-messages-container";
import * as Mod56 from "./discourse/components/chat-messages-scroller";
compatModules["discourse/components/chat-messages-scroller"] = Mod56;

export * as discourse$components$chat__messages__scroller$$__module from "./discourse/components/chat-messages-scroller";
export {
default as discourse$components$chat__messages__scroller$$default
} from "./discourse/components/chat-messages-scroller";
import * as Mod57 from "./discourse/components/chat-notice";
compatModules["discourse/components/chat-notice"] = Mod57;

export * as discourse$components$chat__notice$$__module from "./discourse/components/chat-notice";
export {
default as discourse$components$chat__notice$$default
} from "./discourse/components/chat-notice";
import * as Mod58 from "./discourse/components/chat-notices";
compatModules["discourse/components/chat-notices"] = Mod58;

export * as discourse$components$chat__notices$$__module from "./discourse/components/chat-notices";
export {
default as discourse$components$chat__notices$$default
} from "./discourse/components/chat-notices";
import * as Mod59 from "./discourse/components/chat-pinned-messages-list";
compatModules["discourse/components/chat-pinned-messages-list"] = Mod59;

export * as discourse$components$chat__pinned__messages__list$$__module from "./discourse/components/chat-pinned-messages-list";
export {
default as discourse$components$chat__pinned__messages__list$$default
} from "./discourse/components/chat-pinned-messages-list";
import * as Mod60 from "./discourse/components/chat-replying-indicator";
compatModules["discourse/components/chat-replying-indicator"] = Mod60;

export * as discourse$components$chat__replying__indicator$$__module from "./discourse/components/chat-replying-indicator";
export {
default as discourse$components$chat__replying__indicator$$default
} from "./discourse/components/chat-replying-indicator";
import * as Mod61 from "./discourse/components/chat-retention-reminder-text";
compatModules["discourse/components/chat-retention-reminder-text"] = Mod61;

export * as discourse$components$chat__retention__reminder__text$$__module from "./discourse/components/chat-retention-reminder-text";
export {
default as discourse$components$chat__retention__reminder__text$$default
} from "./discourse/components/chat-retention-reminder-text";
import * as Mod62 from "./discourse/components/chat-retention-reminder";
compatModules["discourse/components/chat-retention-reminder"] = Mod62;

export * as discourse$components$chat__retention__reminder$$__module from "./discourse/components/chat-retention-reminder";
export {
default as discourse$components$chat__retention__reminder$$default
} from "./discourse/components/chat-retention-reminder";
import * as Mod63 from "./discourse/components/chat-search";
compatModules["discourse/components/chat-search"] = Mod63;

export * as discourse$components$chat__search$$__module from "./discourse/components/chat-search";
export {
default as discourse$components$chat__search$$default
} from "./discourse/components/chat-search";
import * as Mod64 from "./discourse/components/chat-side-panel-resizer";
compatModules["discourse/components/chat-side-panel-resizer"] = Mod64;

export * as discourse$components$chat__side__panel__resizer$$__module from "./discourse/components/chat-side-panel-resizer";
export {
default as discourse$components$chat__side__panel__resizer$$default
} from "./discourse/components/chat-side-panel-resizer";
import * as Mod65 from "./discourse/components/chat-side-panel";
compatModules["discourse/components/chat-side-panel"] = Mod65;

export * as discourse$components$chat__side__panel$$__module from "./discourse/components/chat-side-panel";
export {
default as discourse$components$chat__side__panel$$default
} from "./discourse/components/chat-side-panel";
import * as Mod66 from "./discourse/components/chat-sidebar-indicators";
compatModules["discourse/components/chat-sidebar-indicators"] = Mod66;

export * as discourse$components$chat__sidebar__indicators$$__module from "./discourse/components/chat-sidebar-indicators";
export {
default as discourse$components$chat__sidebar__indicators$$default
} from "./discourse/components/chat-sidebar-indicators";
import * as Mod67 from "./discourse/components/chat-skeleton";
compatModules["discourse/components/chat-skeleton"] = Mod67;

export * as discourse$components$chat__skeleton$$__module from "./discourse/components/chat-skeleton";
export {
default as discourse$components$chat__skeleton$$default
} from "./discourse/components/chat-skeleton";
import * as Mod68 from "./discourse/components/chat-thread-heading";
compatModules["discourse/components/chat-thread-heading"] = Mod68;

export * as discourse$components$chat__thread__heading$$__module from "./discourse/components/chat-thread-heading";
export {
default as discourse$components$chat__thread__heading$$default
} from "./discourse/components/chat-thread-heading";
import * as Mod69 from "./discourse/components/chat-thread-list";
compatModules["discourse/components/chat-thread-list"] = Mod69;

export * as discourse$components$chat__thread__list$$__module from "./discourse/components/chat-thread-list";
export {
default as discourse$components$chat__thread__list$$default
} from "./discourse/components/chat-thread-list";
import * as Mod70 from "./discourse/components/chat-thread-participants";
compatModules["discourse/components/chat-thread-participants"] = Mod70;

export * as discourse$components$chat__thread__participants$$__module from "./discourse/components/chat-thread-participants";
export {
default as discourse$components$chat__thread__participants$$default
} from "./discourse/components/chat-thread-participants";
import * as Mod71 from "./discourse/components/chat-thread-title-prompt";
compatModules["discourse/components/chat-thread-title-prompt"] = Mod71;

export * as discourse$components$chat__thread__title__prompt$$__module from "./discourse/components/chat-thread-title-prompt";
export {
default as discourse$components$chat__thread__title__prompt$$default
} from "./discourse/components/chat-thread-title-prompt";
import * as Mod72 from "./discourse/components/chat-thread";
compatModules["discourse/components/chat-thread"] = Mod72;

export * as discourse$components$chat__thread$$__module from "./discourse/components/chat-thread";
export {
default as discourse$components$chat__thread$$default
} from "./discourse/components/chat-thread";
import * as Mod73 from "./discourse/components/chat-to-topic-selector";
compatModules["discourse/components/chat-to-topic-selector"] = Mod73;

export * as discourse$components$chat__to__topic__selector$$__module from "./discourse/components/chat-to-topic-selector";
export {
NEW_TOPIC_SELECTION as discourse$components$chat__to__topic__selector$$NEW_TOPIC_SELECTION,
EXISTING_TOPIC_SELECTION as discourse$components$chat__to__topic__selector$$EXISTING_TOPIC_SELECTION,
NEW_MESSAGE_SELECTION as discourse$components$chat__to__topic__selector$$NEW_MESSAGE_SELECTION,
default as discourse$components$chat__to__topic__selector$$default
} from "./discourse/components/chat-to-topic-selector";
import * as Mod74 from "./discourse/components/chat-upload-drop-zone";
compatModules["discourse/components/chat-upload-drop-zone"] = Mod74;

export * as discourse$components$chat__upload__drop__zone$$__module from "./discourse/components/chat-upload-drop-zone";
export {
default as discourse$components$chat__upload__drop__zone$$default
} from "./discourse/components/chat-upload-drop-zone";
import * as Mod75 from "./discourse/components/chat-upload";
compatModules["discourse/components/chat-upload"] = Mod75;

export * as discourse$components$chat__upload$$__module from "./discourse/components/chat-upload";
export {
default as discourse$components$chat__upload$$default
} from "./discourse/components/chat-upload";
import * as Mod76 from "./discourse/components/chat-user-avatar";
compatModules["discourse/components/chat-user-avatar"] = Mod76;

export * as discourse$components$chat__user__avatar$$__module from "./discourse/components/chat-user-avatar";
export {
default as discourse$components$chat__user__avatar$$default
} from "./discourse/components/chat-user-avatar";
import * as Mod77 from "./discourse/components/chat-user-display-name";
compatModules["discourse/components/chat-user-display-name"] = Mod77;

export * as discourse$components$chat__user__display__name$$__module from "./discourse/components/chat-user-display-name";
export {
default as discourse$components$chat__user__display__name$$default
} from "./discourse/components/chat-user-display-name";
import * as Mod78 from "./discourse/components/chat-user-info";
compatModules["discourse/components/chat-user-info"] = Mod78;

export * as discourse$components$chat__user__info$$__module from "./discourse/components/chat-user-info";
export {
default as discourse$components$chat__user__info$$default
} from "./discourse/components/chat-user-info";
import * as Mod79 from "./discourse/components/chat/composer/button";
compatModules["discourse/components/chat/composer/button"] = Mod79;

export * as discourse$components$chat$composer$button$$__module from "./discourse/components/chat/composer/button";
export {
default as discourse$components$chat$composer$button$$default
} from "./discourse/components/chat/composer/button";
import * as Mod80 from "./discourse/components/chat/composer/channel";
compatModules["discourse/components/chat/composer/channel"] = Mod80;

export * as discourse$components$chat$composer$channel$$__module from "./discourse/components/chat/composer/channel";
export {
default as discourse$components$chat$composer$channel$$default
} from "./discourse/components/chat/composer/channel";
import * as Mod81 from "./discourse/components/chat/composer/separator";
compatModules["discourse/components/chat/composer/separator"] = Mod81;

export * as discourse$components$chat$composer$separator$$__module from "./discourse/components/chat/composer/separator";
export {
default as discourse$components$chat$composer$separator$$default
} from "./discourse/components/chat/composer/separator";
import * as Mod82 from "./discourse/components/chat/composer/thread";
compatModules["discourse/components/chat/composer/thread"] = Mod82;

export * as discourse$components$chat$composer$thread$$__module from "./discourse/components/chat/composer/thread";
export {
default as discourse$components$chat$composer$thread$$default
} from "./discourse/components/chat/composer/thread";
import * as Mod83 from "./discourse/components/chat/direct-message-button";
compatModules["discourse/components/chat/direct-message-button"] = Mod83;

export * as discourse$components$chat$direct__message__button$$__module from "./discourse/components/chat/direct-message-button";
export {
default as discourse$components$chat$direct__message__button$$default
} from "./discourse/components/chat/direct-message-button";
import * as Mod84 from "./discourse/components/chat/drawer-routes/browse";
compatModules["discourse/components/chat/drawer-routes/browse"] = Mod84;

export * as discourse$components$chat$drawer__routes$browse$$__module from "./discourse/components/chat/drawer-routes/browse";
export {
default as discourse$components$chat$drawer__routes$browse$$default
} from "./discourse/components/chat/drawer-routes/browse";
import * as Mod85 from "./discourse/components/chat/drawer-routes/channel-info-members";
compatModules["discourse/components/chat/drawer-routes/channel-info-members"] = Mod85;

export * as discourse$components$chat$drawer__routes$channel__info__members$$__module from "./discourse/components/chat/drawer-routes/channel-info-members";
export {
default as discourse$components$chat$drawer__routes$channel__info__members$$default
} from "./discourse/components/chat/drawer-routes/channel-info-members";
import * as Mod86 from "./discourse/components/chat/drawer-routes/channel-info-settings";
compatModules["discourse/components/chat/drawer-routes/channel-info-settings"] = Mod86;

export * as discourse$components$chat$drawer__routes$channel__info__settings$$__module from "./discourse/components/chat/drawer-routes/channel-info-settings";
export {
default as discourse$components$chat$drawer__routes$channel__info__settings$$default
} from "./discourse/components/chat/drawer-routes/channel-info-settings";
import * as Mod87 from "./discourse/components/chat/drawer-routes/channel-pins";
compatModules["discourse/components/chat/drawer-routes/channel-pins"] = Mod87;

export * as discourse$components$chat$drawer__routes$channel__pins$$__module from "./discourse/components/chat/drawer-routes/channel-pins";
export {
default as discourse$components$chat$drawer__routes$channel__pins$$default
} from "./discourse/components/chat/drawer-routes/channel-pins";
import * as Mod88 from "./discourse/components/chat/drawer-routes/channel-thread";
compatModules["discourse/components/chat/drawer-routes/channel-thread"] = Mod88;

export * as discourse$components$chat$drawer__routes$channel__thread$$__module from "./discourse/components/chat/drawer-routes/channel-thread";
export {
default as discourse$components$chat$drawer__routes$channel__thread$$default
} from "./discourse/components/chat/drawer-routes/channel-thread";
import * as Mod89 from "./discourse/components/chat/drawer-routes/channel-threads";
compatModules["discourse/components/chat/drawer-routes/channel-threads"] = Mod89;

export * as discourse$components$chat$drawer__routes$channel__threads$$__module from "./discourse/components/chat/drawer-routes/channel-threads";
export {
default as discourse$components$chat$drawer__routes$channel__threads$$default
} from "./discourse/components/chat/drawer-routes/channel-threads";
import * as Mod90 from "./discourse/components/chat/drawer-routes/channel";
compatModules["discourse/components/chat/drawer-routes/channel"] = Mod90;

export * as discourse$components$chat$drawer__routes$channel$$__module from "./discourse/components/chat/drawer-routes/channel";
export {
default as discourse$components$chat$drawer__routes$channel$$default
} from "./discourse/components/chat/drawer-routes/channel";
import * as Mod91 from "./discourse/components/chat/drawer-routes/channels";
compatModules["discourse/components/chat/drawer-routes/channels"] = Mod91;

export * as discourse$components$chat$drawer__routes$channels$$__module from "./discourse/components/chat/drawer-routes/channels";
export {
default as discourse$components$chat$drawer__routes$channels$$default
} from "./discourse/components/chat/drawer-routes/channels";
import * as Mod92 from "./discourse/components/chat/drawer-routes/direct-messages";
compatModules["discourse/components/chat/drawer-routes/direct-messages"] = Mod92;

export * as discourse$components$chat$drawer__routes$direct__messages$$__module from "./discourse/components/chat/drawer-routes/direct-messages";
export {
default as discourse$components$chat$drawer__routes$direct__messages$$default
} from "./discourse/components/chat/drawer-routes/direct-messages";
import * as Mod93 from "./discourse/components/chat/drawer-routes/search";
compatModules["discourse/components/chat/drawer-routes/search"] = Mod93;

export * as discourse$components$chat$drawer__routes$search$$__module from "./discourse/components/chat/drawer-routes/search";
export {
default as discourse$components$chat$drawer__routes$search$$default
} from "./discourse/components/chat/drawer-routes/search";
import * as Mod94 from "./discourse/components/chat/drawer-routes/starred-channels";
compatModules["discourse/components/chat/drawer-routes/starred-channels"] = Mod94;

export * as discourse$components$chat$drawer__routes$starred__channels$$__module from "./discourse/components/chat/drawer-routes/starred-channels";
export {
default as discourse$components$chat$drawer__routes$starred__channels$$default
} from "./discourse/components/chat/drawer-routes/starred-channels";
import * as Mod95 from "./discourse/components/chat/drawer-routes/threads";
compatModules["discourse/components/chat/drawer-routes/threads"] = Mod95;

export * as discourse$components$chat$drawer__routes$threads$$__module from "./discourse/components/chat/drawer-routes/threads";
export {
default as discourse$components$chat$drawer__routes$threads$$default
} from "./discourse/components/chat/drawer-routes/threads";
import * as Mod96 from "./discourse/components/chat/footer/unread-indicator";
compatModules["discourse/components/chat/footer/unread-indicator"] = Mod96;

export * as discourse$components$chat$footer$unread__indicator$$__module from "./discourse/components/chat/footer/unread-indicator";
export {
UnreadChannelsIndicator as discourse$components$chat$footer$unread__indicator$$UnreadChannelsIndicator,
UnreadDirectMessagesIndicator as discourse$components$chat$footer$unread__indicator$$UnreadDirectMessagesIndicator,
UnreadStarredIndicator as discourse$components$chat$footer$unread__indicator$$UnreadStarredIndicator,
UnreadThreadsIndicator as discourse$components$chat$footer$unread__indicator$$UnreadThreadsIndicator,
default as discourse$components$chat$footer$unread__indicator$$default
} from "./discourse/components/chat/footer/unread-indicator";
import * as Mod97 from "./discourse/components/chat/form";
compatModules["discourse/components/chat/form"] = Mod97;

export * as discourse$components$chat$form$$__module from "./discourse/components/chat/form";
export {
default as discourse$components$chat$form$$default
} from "./discourse/components/chat/form";
import * as Mod98 from "./discourse/components/chat/form/row";
compatModules["discourse/components/chat/form/row"] = Mod98;

export * as discourse$components$chat$form$row$$__module from "./discourse/components/chat/form/row";
export {
default as discourse$components$chat$form$row$$default
} from "./discourse/components/chat/form/row";
import * as Mod99 from "./discourse/components/chat/form/section";
compatModules["discourse/components/chat/form/section"] = Mod99;

export * as discourse$components$chat$form$section$$__module from "./discourse/components/chat/form/section";
export {
default as discourse$components$chat$form$section$$default
} from "./discourse/components/chat/form/section";
import * as Mod100 from "./discourse/components/chat/header/icon";
compatModules["discourse/components/chat/header/icon"] = Mod100;

export * as discourse$components$chat$header$icon$$__module from "./discourse/components/chat/header/icon";
export {
default as discourse$components$chat$header$icon$$default
} from "./discourse/components/chat/header/icon";
import * as Mod101 from "./discourse/components/chat/header/icon/unread-indicator";
compatModules["discourse/components/chat/header/icon/unread-indicator"] = Mod101;

export * as discourse$components$chat$header$icon$unread__indicator$$__module from "./discourse/components/chat/header/icon/unread-indicator";
export {
default as discourse$components$chat$header$icon$unread__indicator$$default
} from "./discourse/components/chat/header/icon/unread-indicator";
import * as Mod102 from "./discourse/components/chat/list/empty-state";
compatModules["discourse/components/chat/list/empty-state"] = Mod102;

export * as discourse$components$chat$list$empty__state$$__module from "./discourse/components/chat/list/empty-state";
export {
default as discourse$components$chat$list$empty__state$$default
} from "./discourse/components/chat/list/empty-state";
import * as Mod103 from "./discourse/components/chat/list/index";
compatModules["discourse/components/chat/list/index"] = Mod103;

export * as discourse$components$chat$list$index$$__module from "./discourse/components/chat/list/index";
export {
default as discourse$components$chat$list$index$$default,
default as discourse$components$chat$list$$default
} from "./discourse/components/chat/list/index";
import * as Mod104 from "./discourse/components/chat/list/item";
compatModules["discourse/components/chat/list/item"] = Mod104;

export * as discourse$components$chat$list$item$$__module from "./discourse/components/chat/list/item";
export {
default as discourse$components$chat$list$item$$default
} from "./discourse/components/chat/list/item";
import * as Mod105 from "./discourse/components/chat/message-creator/add-members";
compatModules["discourse/components/chat/message-creator/add-members"] = Mod105;

export * as discourse$components$chat$message__creator$add__members$$__module from "./discourse/components/chat/message-creator/add-members";
export {
default as discourse$components$chat$message__creator$add__members$$default
} from "./discourse/components/chat/message-creator/add-members";
import * as Mod106 from "./discourse/components/chat/message-creator/channel";
compatModules["discourse/components/chat/message-creator/channel"] = Mod106;

export * as discourse$components$chat$message__creator$channel$$__module from "./discourse/components/chat/message-creator/channel";
export {
default as discourse$components$chat$message__creator$channel$$default
} from "./discourse/components/chat/message-creator/channel";
import * as Mod107 from "./discourse/components/chat/message-creator/constants";
compatModules["discourse/components/chat/message-creator/constants"] = Mod107;

export * as discourse$components$chat$message__creator$constants$$__module from "./discourse/components/chat/message-creator/constants";
export {
MODES as discourse$components$chat$message__creator$constants$$MODES
} from "./discourse/components/chat/message-creator/constants";
import * as Mod108 from "./discourse/components/chat/message-creator/group";
compatModules["discourse/components/chat/message-creator/group"] = Mod108;

export * as discourse$components$chat$message__creator$group$$__module from "./discourse/components/chat/message-creator/group";
export {
default as discourse$components$chat$message__creator$group$$default
} from "./discourse/components/chat/message-creator/group";
import * as Mod109 from "./discourse/components/chat/message-creator/index";
compatModules["discourse/components/chat/message-creator/index"] = Mod109;

export * as discourse$components$chat$message__creator$index$$__module from "./discourse/components/chat/message-creator/index";
export {
default as discourse$components$chat$message__creator$index$$default,
default as discourse$components$chat$message__creator$$default
} from "./discourse/components/chat/message-creator/index";
import * as Mod110 from "./discourse/components/chat/message-creator/lib/chatables-loader";
compatModules["discourse/components/chat/message-creator/lib/chatables-loader"] = Mod110;

export * as discourse$components$chat$message__creator$lib$chatables__loader$$__module from "./discourse/components/chat/message-creator/lib/chatables-loader";
export {
sortChatables as discourse$components$chat$message__creator$lib$chatables__loader$$sortChatables,
default as discourse$components$chat$message__creator$lib$chatables__loader$$default
} from "./discourse/components/chat/message-creator/lib/chatables-loader";
import * as Mod111 from "./discourse/components/chat/message-creator/lib/iterate-list";
compatModules["discourse/components/chat/message-creator/lib/iterate-list"] = Mod111;

export * as discourse$components$chat$message__creator$lib$iterate__list$$__module from "./discourse/components/chat/message-creator/lib/iterate-list";
export {
getNext as discourse$components$chat$message__creator$lib$iterate__list$$getNext,
getPrevious as discourse$components$chat$message__creator$lib$iterate__list$$getPrevious
} from "./discourse/components/chat/message-creator/lib/iterate-list";
import * as Mod112 from "./discourse/components/chat/message-creator/list-action";
compatModules["discourse/components/chat/message-creator/list-action"] = Mod112;

export * as discourse$components$chat$message__creator$list__action$$__module from "./discourse/components/chat/message-creator/list-action";
export {
default as discourse$components$chat$message__creator$list__action$$default
} from "./discourse/components/chat/message-creator/list-action";
import * as Mod113 from "./discourse/components/chat/message-creator/list-handler";
compatModules["discourse/components/chat/message-creator/list-handler"] = Mod113;

export * as discourse$components$chat$message__creator$list__handler$$__module from "./discourse/components/chat/message-creator/list-handler";
export {
default as discourse$components$chat$message__creator$list__handler$$default
} from "./discourse/components/chat/message-creator/list-handler";
import * as Mod114 from "./discourse/components/chat/message-creator/list";
compatModules["discourse/components/chat/message-creator/list"] = Mod114;

export * as discourse$components$chat$message__creator$list$$__module from "./discourse/components/chat/message-creator/list";
export {
default as discourse$components$chat$message__creator$list$$default
} from "./discourse/components/chat/message-creator/list";
import * as Mod115 from "./discourse/components/chat/message-creator/member";
compatModules["discourse/components/chat/message-creator/member"] = Mod115;

export * as discourse$components$chat$message__creator$member$$__module from "./discourse/components/chat/message-creator/member";
export {
default as discourse$components$chat$message__creator$member$$default
} from "./discourse/components/chat/message-creator/member";
import * as Mod116 from "./discourse/components/chat/message-creator/members-count";
compatModules["discourse/components/chat/message-creator/members-count"] = Mod116;

export * as discourse$components$chat$message__creator$members__count$$__module from "./discourse/components/chat/message-creator/members-count";
export {
default as discourse$components$chat$message__creator$members__count$$default
} from "./discourse/components/chat/message-creator/members-count";
import * as Mod117 from "./discourse/components/chat/message-creator/members-selector";
compatModules["discourse/components/chat/message-creator/members-selector"] = Mod117;

export * as discourse$components$chat$message__creator$members__selector$$__module from "./discourse/components/chat/message-creator/members-selector";
export {
default as discourse$components$chat$message__creator$members__selector$$default
} from "./discourse/components/chat/message-creator/members-selector";
import * as Mod118 from "./discourse/components/chat/message-creator/members";
compatModules["discourse/components/chat/message-creator/members"] = Mod118;

export * as discourse$components$chat$message__creator$members$$__module from "./discourse/components/chat/message-creator/members";
export {
default as discourse$components$chat$message__creator$members$$default
} from "./discourse/components/chat/message-creator/members";
import * as Mod119 from "./discourse/components/chat/message-creator/new-group";
compatModules["discourse/components/chat/message-creator/new-group"] = Mod119;

export * as discourse$components$chat$message__creator$new__group$$__module from "./discourse/components/chat/message-creator/new-group";
export {
default as discourse$components$chat$message__creator$new__group$$default
} from "./discourse/components/chat/message-creator/new-group";
import * as Mod120 from "./discourse/components/chat/message-creator/search-input";
compatModules["discourse/components/chat/message-creator/search-input"] = Mod120;

export * as discourse$components$chat$message__creator$search__input$$__module from "./discourse/components/chat/message-creator/search-input";
export {
default as discourse$components$chat$message__creator$search__input$$default
} from "./discourse/components/chat/message-creator/search-input";
import * as Mod121 from "./discourse/components/chat/message-creator/search";
compatModules["discourse/components/chat/message-creator/search"] = Mod121;

export * as discourse$components$chat$message__creator$search$$__module from "./discourse/components/chat/message-creator/search";
export {
default as discourse$components$chat$message__creator$search$$default
} from "./discourse/components/chat/message-creator/search";
import * as Mod122 from "./discourse/components/chat/message-creator/user";
compatModules["discourse/components/chat/message-creator/user"] = Mod122;

export * as discourse$components$chat$message__creator$user$$__module from "./discourse/components/chat/message-creator/user";
export {
default as discourse$components$chat$message__creator$user$$default
} from "./discourse/components/chat/message-creator/user";
import * as Mod123 from "./discourse/components/chat/message/avatar";
compatModules["discourse/components/chat/message/avatar"] = Mod123;

export * as discourse$components$chat$message$avatar$$__module from "./discourse/components/chat/message/avatar";
export {
default as discourse$components$chat$message$avatar$$default
} from "./discourse/components/chat/message/avatar";
import * as Mod124 from "./discourse/components/chat/message/error";
compatModules["discourse/components/chat/message/error"] = Mod124;

export * as discourse$components$chat$message$error$$__module from "./discourse/components/chat/message/error";
export {
default as discourse$components$chat$message$error$$default
} from "./discourse/components/chat/message/error";
import * as Mod125 from "./discourse/components/chat/message/info";
compatModules["discourse/components/chat/message/info"] = Mod125;

export * as discourse$components$chat$message$info$$__module from "./discourse/components/chat/message/info";
export {
default as discourse$components$chat$message$info$$default
} from "./discourse/components/chat/message/info";
import * as Mod126 from "./discourse/components/chat/message/left-gutter";
compatModules["discourse/components/chat/message/left-gutter"] = Mod126;

export * as discourse$components$chat$message$left__gutter$$__module from "./discourse/components/chat/message/left-gutter";
export {
default as discourse$components$chat$message$left__gutter$$default
} from "./discourse/components/chat/message/left-gutter";
import * as Mod127 from "./discourse/components/chat/modal/archive-channel";
compatModules["discourse/components/chat/modal/archive-channel"] = Mod127;

export * as discourse$components$chat$modal$archive__channel$$__module from "./discourse/components/chat/modal/archive-channel";
export {
default as discourse$components$chat$modal$archive__channel$$default
} from "./discourse/components/chat/modal/archive-channel";
import * as Mod128 from "./discourse/components/chat/modal/create-channel";
compatModules["discourse/components/chat/modal/create-channel"] = Mod128;

export * as discourse$components$chat$modal$create__channel$$__module from "./discourse/components/chat/modal/create-channel";
export {
default as discourse$components$chat$modal$create__channel$$default
} from "./discourse/components/chat/modal/create-channel";
import * as Mod129 from "./discourse/components/chat/modal/delete-channel";
compatModules["discourse/components/chat/modal/delete-channel"] = Mod129;

export * as discourse$components$chat$modal$delete__channel$$__module from "./discourse/components/chat/modal/delete-channel";
export {
default as discourse$components$chat$modal$delete__channel$$default
} from "./discourse/components/chat/modal/delete-channel";
import * as Mod130 from "./discourse/components/chat/modal/delete-messages-confirm";
compatModules["discourse/components/chat/modal/delete-messages-confirm"] = Mod130;

export * as discourse$components$chat$modal$delete__messages__confirm$$__module from "./discourse/components/chat/modal/delete-messages-confirm";
export {
default as discourse$components$chat$modal$delete__messages__confirm$$default
} from "./discourse/components/chat/modal/delete-messages-confirm";
import * as Mod131 from "./discourse/components/chat/modal/edit-channel-description";
compatModules["discourse/components/chat/modal/edit-channel-description"] = Mod131;

export * as discourse$components$chat$modal$edit__channel__description$$__module from "./discourse/components/chat/modal/edit-channel-description";
export {
default as discourse$components$chat$modal$edit__channel__description$$default
} from "./discourse/components/chat/modal/edit-channel-description";
import * as Mod132 from "./discourse/components/chat/modal/edit-channel-name";
compatModules["discourse/components/chat/modal/edit-channel-name"] = Mod132;

export * as discourse$components$chat$modal$edit__channel__name$$__module from "./discourse/components/chat/modal/edit-channel-name";
export {
default as discourse$components$chat$modal$edit__channel__name$$default
} from "./discourse/components/chat/modal/edit-channel-name";
import * as Mod133 from "./discourse/components/chat/modal/move-message-to-channel";
compatModules["discourse/components/chat/modal/move-message-to-channel"] = Mod133;

export * as discourse$components$chat$modal$move__message__to__channel$$__module from "./discourse/components/chat/modal/move-message-to-channel";
export {
default as discourse$components$chat$modal$move__message__to__channel$$default
} from "./discourse/components/chat/modal/move-message-to-channel";
import * as Mod134 from "./discourse/components/chat/modal/new-message";
compatModules["discourse/components/chat/modal/new-message"] = Mod134;

export * as discourse$components$chat$modal$new__message$$__module from "./discourse/components/chat/modal/new-message";
export {
default as discourse$components$chat$modal$new__message$$default
} from "./discourse/components/chat/modal/new-message";
import * as Mod135 from "./discourse/components/chat/modal/thread-settings";
compatModules["discourse/components/chat/modal/thread-settings"] = Mod135;

export * as discourse$components$chat$modal$thread__settings$$__module from "./discourse/components/chat/modal/thread-settings";
export {
default as discourse$components$chat$modal$thread__settings$$default
} from "./discourse/components/chat/modal/thread-settings";
import * as Mod136 from "./discourse/components/chat/modal/toggle-channel-status";
compatModules["discourse/components/chat/modal/toggle-channel-status"] = Mod136;

export * as discourse$components$chat$modal$toggle__channel__status$$__module from "./discourse/components/chat/modal/toggle-channel-status";
export {
default as discourse$components$chat$modal$toggle__channel__status$$default
} from "./discourse/components/chat/modal/toggle-channel-status";
import * as Mod137 from "./discourse/components/chat/navbar/actions";
compatModules["discourse/components/chat/navbar/actions"] = Mod137;

export * as discourse$components$chat$navbar$actions$$__module from "./discourse/components/chat/navbar/actions";
export {
default as discourse$components$chat$navbar$actions$$default
} from "./discourse/components/chat/navbar/actions";
import * as Mod138 from "./discourse/components/chat/navbar/back-button";
compatModules["discourse/components/chat/navbar/back-button"] = Mod138;

export * as discourse$components$chat$navbar$back__button$$__module from "./discourse/components/chat/navbar/back-button";
export {
default as discourse$components$chat$navbar$back__button$$default
} from "./discourse/components/chat/navbar/back-button";
import * as Mod139 from "./discourse/components/chat/navbar/browse-channels-button";
compatModules["discourse/components/chat/navbar/browse-channels-button"] = Mod139;

export * as discourse$components$chat$navbar$browse__channels__button$$__module from "./discourse/components/chat/navbar/browse-channels-button";
export {
default as discourse$components$chat$navbar$browse__channels__button$$default
} from "./discourse/components/chat/navbar/browse-channels-button";
import * as Mod140 from "./discourse/components/chat/navbar/channel-title";
compatModules["discourse/components/chat/navbar/channel-title"] = Mod140;

export * as discourse$components$chat$navbar$channel__title$$__module from "./discourse/components/chat/navbar/channel-title";
export {
default as discourse$components$chat$navbar$channel__title$$default
} from "./discourse/components/chat/navbar/channel-title";
import * as Mod141 from "./discourse/components/chat/navbar/close-drawer-button";
compatModules["discourse/components/chat/navbar/close-drawer-button"] = Mod141;

export * as discourse$components$chat$navbar$close__drawer__button$$__module from "./discourse/components/chat/navbar/close-drawer-button";
export {
default as discourse$components$chat$navbar$close__drawer__button$$default
} from "./discourse/components/chat/navbar/close-drawer-button";
import * as Mod142 from "./discourse/components/chat/navbar/close-pins-button";
compatModules["discourse/components/chat/navbar/close-pins-button"] = Mod142;

export * as discourse$components$chat$navbar$close__pins__button$$__module from "./discourse/components/chat/navbar/close-pins-button";
export {
default as discourse$components$chat$navbar$close__pins__button$$default
} from "./discourse/components/chat/navbar/close-pins-button";
import * as Mod143 from "./discourse/components/chat/navbar/close-thread-button";
compatModules["discourse/components/chat/navbar/close-thread-button"] = Mod143;

export * as discourse$components$chat$navbar$close__thread__button$$__module from "./discourse/components/chat/navbar/close-thread-button";
export {
default as discourse$components$chat$navbar$close__thread__button$$default
} from "./discourse/components/chat/navbar/close-thread-button";
import * as Mod144 from "./discourse/components/chat/navbar/close-threads-button";
compatModules["discourse/components/chat/navbar/close-threads-button"] = Mod144;

export * as discourse$components$chat$navbar$close__threads__button$$__module from "./discourse/components/chat/navbar/close-threads-button";
export {
default as discourse$components$chat$navbar$close__threads__button$$default
} from "./discourse/components/chat/navbar/close-threads-button";
import * as Mod145 from "./discourse/components/chat/navbar/filter";
compatModules["discourse/components/chat/navbar/filter"] = Mod145;

export * as discourse$components$chat$navbar$filter$$__module from "./discourse/components/chat/navbar/filter";
export {
default as discourse$components$chat$navbar$filter$$default
} from "./discourse/components/chat/navbar/filter";
import * as Mod146 from "./discourse/components/chat/navbar/full-page-button";
compatModules["discourse/components/chat/navbar/full-page-button"] = Mod146;

export * as discourse$components$chat$navbar$full__page__button$$__module from "./discourse/components/chat/navbar/full-page-button";
export {
default as discourse$components$chat$navbar$full__page__button$$default
} from "./discourse/components/chat/navbar/full-page-button";
import * as Mod147 from "./discourse/components/chat/navbar/index";
compatModules["discourse/components/chat/navbar/index"] = Mod147;

export * as discourse$components$chat$navbar$index$$__module from "./discourse/components/chat/navbar/index";
export {
default as discourse$components$chat$navbar$index$$default,
default as discourse$components$chat$navbar$$default
} from "./discourse/components/chat/navbar/index";
import * as Mod148 from "./discourse/components/chat/navbar/new-channel-button";
compatModules["discourse/components/chat/navbar/new-channel-button"] = Mod148;

export * as discourse$components$chat$navbar$new__channel__button$$__module from "./discourse/components/chat/navbar/new-channel-button";
export {
default as discourse$components$chat$navbar$new__channel__button$$default
} from "./discourse/components/chat/navbar/new-channel-button";
import * as Mod149 from "./discourse/components/chat/navbar/new-direct-message-button";
compatModules["discourse/components/chat/navbar/new-direct-message-button"] = Mod149;

export * as discourse$components$chat$navbar$new__direct__message__button$$__module from "./discourse/components/chat/navbar/new-direct-message-button";
export {
default as discourse$components$chat$navbar$new__direct__message__button$$default
} from "./discourse/components/chat/navbar/new-direct-message-button";
import * as Mod150 from "./discourse/components/chat/navbar/open-drawer-button";
compatModules["discourse/components/chat/navbar/open-drawer-button"] = Mod150;

export * as discourse$components$chat$navbar$open__drawer__button$$__module from "./discourse/components/chat/navbar/open-drawer-button";
export {
default as discourse$components$chat$navbar$open__drawer__button$$default
} from "./discourse/components/chat/navbar/open-drawer-button";
import * as Mod151 from "./discourse/components/chat/navbar/pinned-messages-button";
compatModules["discourse/components/chat/navbar/pinned-messages-button"] = Mod151;

export * as discourse$components$chat$navbar$pinned__messages__button$$__module from "./discourse/components/chat/navbar/pinned-messages-button";
export {
default as discourse$components$chat$navbar$pinned__messages__button$$default
} from "./discourse/components/chat/navbar/pinned-messages-button";
import * as Mod152 from "./discourse/components/chat/navbar/sub-title";
compatModules["discourse/components/chat/navbar/sub-title"] = Mod152;

export * as discourse$components$chat$navbar$sub__title$$__module from "./discourse/components/chat/navbar/sub-title";
export {
default as discourse$components$chat$navbar$sub__title$$default
} from "./discourse/components/chat/navbar/sub-title";
import * as Mod153 from "./discourse/components/chat/navbar/thread-settings-button";
compatModules["discourse/components/chat/navbar/thread-settings-button"] = Mod153;

export * as discourse$components$chat$navbar$thread__settings__button$$__module from "./discourse/components/chat/navbar/thread-settings-button";
export {
default as discourse$components$chat$navbar$thread__settings__button$$default
} from "./discourse/components/chat/navbar/thread-settings-button";
import * as Mod154 from "./discourse/components/chat/navbar/thread-tracking-dropdown";
compatModules["discourse/components/chat/navbar/thread-tracking-dropdown"] = Mod154;

export * as discourse$components$chat$navbar$thread__tracking__dropdown$$__module from "./discourse/components/chat/navbar/thread-tracking-dropdown";
export {
default as discourse$components$chat$navbar$thread__tracking__dropdown$$default
} from "./discourse/components/chat/navbar/thread-tracking-dropdown";
import * as Mod155 from "./discourse/components/chat/navbar/threads-list-button";
compatModules["discourse/components/chat/navbar/threads-list-button"] = Mod155;

export * as discourse$components$chat$navbar$threads__list__button$$__module from "./discourse/components/chat/navbar/threads-list-button";
export {
default as discourse$components$chat$navbar$threads__list__button$$default
} from "./discourse/components/chat/navbar/threads-list-button";
import * as Mod156 from "./discourse/components/chat/navbar/title";
compatModules["discourse/components/chat/navbar/title"] = Mod156;

export * as discourse$components$chat$navbar$title$$__module from "./discourse/components/chat/navbar/title";
export {
default as discourse$components$chat$navbar$title$$default
} from "./discourse/components/chat/navbar/title";
import * as Mod157 from "./discourse/components/chat/navbar/toggle-drawer-button";
compatModules["discourse/components/chat/navbar/toggle-drawer-button"] = Mod157;

export * as discourse$components$chat$navbar$toggle__drawer__button$$__module from "./discourse/components/chat/navbar/toggle-drawer-button";
export {
default as discourse$components$chat$navbar$toggle__drawer__button$$default
} from "./discourse/components/chat/navbar/toggle-drawer-button";
import * as Mod158 from "./discourse/components/chat/notices/mention_without_membership";
compatModules["discourse/components/chat/notices/mention_without_membership"] = Mod158;

export * as discourse$components$chat$notices$mention_without_membership$$__module from "./discourse/components/chat/notices/mention_without_membership";
export {
default as discourse$components$chat$notices$mention_without_membership$$default
} from "./discourse/components/chat/notices/mention_without_membership";
import * as Mod159 from "./discourse/components/chat/pinned-messages-list/header";
compatModules["discourse/components/chat/pinned-messages-list/header"] = Mod159;

export * as discourse$components$chat$pinned__messages__list$header$$__module from "./discourse/components/chat/pinned-messages-list/header";
export {
default as discourse$components$chat$pinned__messages__list$header$$default
} from "./discourse/components/chat/pinned-messages-list/header";
import * as Mod160 from "./discourse/components/chat/routes/channel-info-members";
compatModules["discourse/components/chat/routes/channel-info-members"] = Mod160;

export * as discourse$components$chat$routes$channel__info__members$$__module from "./discourse/components/chat/routes/channel-info-members";
export {
default as discourse$components$chat$routes$channel__info__members$$default
} from "./discourse/components/chat/routes/channel-info-members";
import * as Mod161 from "./discourse/components/chat/routes/channel-info-nav";
compatModules["discourse/components/chat/routes/channel-info-nav"] = Mod161;

export * as discourse$components$chat$routes$channel__info__nav$$__module from "./discourse/components/chat/routes/channel-info-nav";
export {
default as discourse$components$chat$routes$channel__info__nav$$default
} from "./discourse/components/chat/routes/channel-info-nav";
import * as Mod162 from "./discourse/components/chat/routes/channel-info-settings";
compatModules["discourse/components/chat/routes/channel-info-settings"] = Mod162;

export * as discourse$components$chat$routes$channel__info__settings$$__module from "./discourse/components/chat/routes/channel-info-settings";
export {
default as discourse$components$chat$routes$channel__info__settings$$default
} from "./discourse/components/chat/routes/channel-info-settings";
import * as Mod163 from "./discourse/components/chat/routes/channel-info";
compatModules["discourse/components/chat/routes/channel-info"] = Mod163;

export * as discourse$components$chat$routes$channel__info$$__module from "./discourse/components/chat/routes/channel-info";
export {
default as discourse$components$chat$routes$channel__info$$default
} from "./discourse/components/chat/routes/channel-info";
import * as Mod164 from "./discourse/components/chat/routes/channel-pins";
compatModules["discourse/components/chat/routes/channel-pins"] = Mod164;

export * as discourse$components$chat$routes$channel__pins$$__module from "./discourse/components/chat/routes/channel-pins";
export {
default as discourse$components$chat$routes$channel__pins$$default
} from "./discourse/components/chat/routes/channel-pins";
import * as Mod165 from "./discourse/components/chat/routes/channel-thread";
compatModules["discourse/components/chat/routes/channel-thread"] = Mod165;

export * as discourse$components$chat$routes$channel__thread$$__module from "./discourse/components/chat/routes/channel-thread";
export {
default as discourse$components$chat$routes$channel__thread$$default
} from "./discourse/components/chat/routes/channel-thread";
import * as Mod166 from "./discourse/components/chat/routes/channel-threads";
compatModules["discourse/components/chat/routes/channel-threads"] = Mod166;

export * as discourse$components$chat$routes$channel__threads$$__module from "./discourse/components/chat/routes/channel-threads";
export {
default as discourse$components$chat$routes$channel__threads$$default
} from "./discourse/components/chat/routes/channel-threads";
import * as Mod167 from "./discourse/components/chat/routes/channel";
compatModules["discourse/components/chat/routes/channel"] = Mod167;

export * as discourse$components$chat$routes$channel$$__module from "./discourse/components/chat/routes/channel";
export {
default as discourse$components$chat$routes$channel$$default
} from "./discourse/components/chat/routes/channel";
import * as Mod168 from "./discourse/components/chat/routes/channels";
compatModules["discourse/components/chat/routes/channels"] = Mod168;

export * as discourse$components$chat$routes$channels$$__module from "./discourse/components/chat/routes/channels";
export {
default as discourse$components$chat$routes$channels$$default
} from "./discourse/components/chat/routes/channels";
import * as Mod169 from "./discourse/components/chat/routes/direct-messages";
compatModules["discourse/components/chat/routes/direct-messages"] = Mod169;

export * as discourse$components$chat$routes$direct__messages$$__module from "./discourse/components/chat/routes/direct-messages";
export {
default as discourse$components$chat$routes$direct__messages$$default
} from "./discourse/components/chat/routes/direct-messages";
import * as Mod170 from "./discourse/components/chat/routes/search";
compatModules["discourse/components/chat/routes/search"] = Mod170;

export * as discourse$components$chat$routes$search$$__module from "./discourse/components/chat/routes/search";
export {
default as discourse$components$chat$routes$search$$default
} from "./discourse/components/chat/routes/search";
import * as Mod171 from "./discourse/components/chat/routes/starred-channels";
compatModules["discourse/components/chat/routes/starred-channels"] = Mod171;

export * as discourse$components$chat$routes$starred__channels$$__module from "./discourse/components/chat/routes/starred-channels";
export {
default as discourse$components$chat$routes$starred__channels$$default
} from "./discourse/components/chat/routes/starred-channels";
import * as Mod172 from "./discourse/components/chat/routes/threads";
compatModules["discourse/components/chat/routes/threads"] = Mod172;

export * as discourse$components$chat$routes$threads$$__module from "./discourse/components/chat/routes/threads";
export {
default as discourse$components$chat$routes$threads$$default
} from "./discourse/components/chat/routes/threads";
import * as Mod173 from "./discourse/components/chat/scroll-to-bottom-arrow";
compatModules["discourse/components/chat/scroll-to-bottom-arrow"] = Mod173;

export * as discourse$components$chat$scroll__to__bottom__arrow$$__module from "./discourse/components/chat/scroll-to-bottom-arrow";
export {
default as discourse$components$chat$scroll__to__bottom__arrow$$default
} from "./discourse/components/chat/scroll-to-bottom-arrow";
import * as Mod174 from "./discourse/components/chat/selection-manager";
compatModules["discourse/components/chat/selection-manager"] = Mod174;

export * as discourse$components$chat$selection__manager$$__module from "./discourse/components/chat/selection-manager";
export {
default as discourse$components$chat$selection__manager$$default
} from "./discourse/components/chat/selection-manager";
import * as Mod175 from "./discourse/components/chat/thread-list/header";
compatModules["discourse/components/chat/thread-list/header"] = Mod175;

export * as discourse$components$chat$thread__list$header$$__module from "./discourse/components/chat/thread-list/header";
export {
default as discourse$components$chat$thread__list$header$$default
} from "./discourse/components/chat/thread-list/header";
import * as Mod176 from "./discourse/components/chat/thread-list/item";
compatModules["discourse/components/chat/thread-list/item"] = Mod176;

export * as discourse$components$chat$thread__list$item$$__module from "./discourse/components/chat/thread-list/item";
export {
default as discourse$components$chat$thread__list$item$$default
} from "./discourse/components/chat/thread-list/item";
import * as Mod177 from "./discourse/components/chat/thread/header-unread-indicator";
compatModules["discourse/components/chat/thread/header-unread-indicator"] = Mod177;

export * as discourse$components$chat$thread$header__unread__indicator$$__module from "./discourse/components/chat/thread/header-unread-indicator";
export {
default as discourse$components$chat$thread$header__unread__indicator$$default
} from "./discourse/components/chat/thread/header-unread-indicator";
import * as Mod178 from "./discourse/components/chat/thread/header";
compatModules["discourse/components/chat/thread/header"] = Mod178;

export * as discourse$components$chat$thread$header$$__module from "./discourse/components/chat/thread/header";
export {
default as discourse$components$chat$thread$header$$default
} from "./discourse/components/chat/thread/header";
import * as Mod179 from "./discourse/components/collapser";
compatModules["discourse/components/collapser"] = Mod179;

export * as discourse$components$collapser$$__module from "./discourse/components/collapser";
export {
default as discourse$components$collapser$$default
} from "./discourse/components/collapser";
import * as Mod180 from "./discourse/components/full-page-chat";
compatModules["discourse/components/full-page-chat"] = Mod180;

export * as discourse$components$full__page__chat$$__module from "./discourse/components/full-page-chat";
export {
default as discourse$components$full__page__chat$$default
} from "./discourse/components/full-page-chat";
import * as Mod181 from "./discourse/components/reviewable/chat-message";
compatModules["discourse/components/reviewable/chat-message"] = Mod181;

export * as discourse$components$reviewable$chat__message$$__module from "./discourse/components/reviewable/chat-message";
export {
default as discourse$components$reviewable$chat__message$$default
} from "./discourse/components/reviewable/chat-message";
import * as Mod182 from "./discourse/components/styleguide/chat-composer-message-details";
compatModules["discourse/components/styleguide/chat-composer-message-details"] = Mod182;

export * as discourse$components$styleguide$chat__composer__message__details$$__module from "./discourse/components/styleguide/chat-composer-message-details";
export {
default as discourse$components$styleguide$chat__composer__message__details$$default
} from "./discourse/components/styleguide/chat-composer-message-details";
import * as Mod183 from "./discourse/components/styleguide/chat-composer";
compatModules["discourse/components/styleguide/chat-composer"] = Mod183;

export * as discourse$components$styleguide$chat__composer$$__module from "./discourse/components/styleguide/chat-composer";
export {
default as discourse$components$styleguide$chat__composer$$default
} from "./discourse/components/styleguide/chat-composer";
import * as Mod184 from "./discourse/components/styleguide/chat-header-icon";
compatModules["discourse/components/styleguide/chat-header-icon"] = Mod184;

export * as discourse$components$styleguide$chat__header__icon$$__module from "./discourse/components/styleguide/chat-header-icon";
export {
default as discourse$components$styleguide$chat__header__icon$$default
} from "./discourse/components/styleguide/chat-header-icon";
import * as Mod185 from "./discourse/components/styleguide/chat-message";
compatModules["discourse/components/styleguide/chat-message"] = Mod185;

export * as discourse$components$styleguide$chat__message$$__module from "./discourse/components/styleguide/chat-message";
export {
default as discourse$components$styleguide$chat__message$$default
} from "./discourse/components/styleguide/chat-message";
import * as Mod186 from "./discourse/components/styleguide/chat-modal-archive-channel";
compatModules["discourse/components/styleguide/chat-modal-archive-channel"] = Mod186;

export * as discourse$components$styleguide$chat__modal__archive__channel$$__module from "./discourse/components/styleguide/chat-modal-archive-channel";
export {
default as discourse$components$styleguide$chat__modal__archive__channel$$default
} from "./discourse/components/styleguide/chat-modal-archive-channel";
import * as Mod187 from "./discourse/components/styleguide/chat-modal-create-channel";
compatModules["discourse/components/styleguide/chat-modal-create-channel"] = Mod187;

export * as discourse$components$styleguide$chat__modal__create__channel$$__module from "./discourse/components/styleguide/chat-modal-create-channel";
export {
default as discourse$components$styleguide$chat__modal__create__channel$$default
} from "./discourse/components/styleguide/chat-modal-create-channel";
import * as Mod188 from "./discourse/components/styleguide/chat-modal-delete-channel";
compatModules["discourse/components/styleguide/chat-modal-delete-channel"] = Mod188;

export * as discourse$components$styleguide$chat__modal__delete__channel$$__module from "./discourse/components/styleguide/chat-modal-delete-channel";
export {
default as discourse$components$styleguide$chat__modal__delete__channel$$default
} from "./discourse/components/styleguide/chat-modal-delete-channel";
import * as Mod189 from "./discourse/components/styleguide/chat-modal-edit-channel-description";
compatModules["discourse/components/styleguide/chat-modal-edit-channel-description"] = Mod189;

export * as discourse$components$styleguide$chat__modal__edit__channel__description$$__module from "./discourse/components/styleguide/chat-modal-edit-channel-description";
export {
default as discourse$components$styleguide$chat__modal__edit__channel__description$$default
} from "./discourse/components/styleguide/chat-modal-edit-channel-description";
import * as Mod190 from "./discourse/components/styleguide/chat-modal-edit-channel-name";
compatModules["discourse/components/styleguide/chat-modal-edit-channel-name"] = Mod190;

export * as discourse$components$styleguide$chat__modal__edit__channel__name$$__module from "./discourse/components/styleguide/chat-modal-edit-channel-name";
export {
default as discourse$components$styleguide$chat__modal__edit__channel__name$$default
} from "./discourse/components/styleguide/chat-modal-edit-channel-name";
import * as Mod191 from "./discourse/components/styleguide/chat-modal-move-message-to-channel";
compatModules["discourse/components/styleguide/chat-modal-move-message-to-channel"] = Mod191;

export * as discourse$components$styleguide$chat__modal__move__message__to__channel$$__module from "./discourse/components/styleguide/chat-modal-move-message-to-channel";
export {
default as discourse$components$styleguide$chat__modal__move__message__to__channel$$default
} from "./discourse/components/styleguide/chat-modal-move-message-to-channel";
import * as Mod192 from "./discourse/components/styleguide/chat-modal-new-message";
compatModules["discourse/components/styleguide/chat-modal-new-message"] = Mod192;

export * as discourse$components$styleguide$chat__modal__new__message$$__module from "./discourse/components/styleguide/chat-modal-new-message";
export {
default as discourse$components$styleguide$chat__modal__new__message$$default
} from "./discourse/components/styleguide/chat-modal-new-message";
import * as Mod193 from "./discourse/components/styleguide/chat-modal-thread-settings";
compatModules["discourse/components/styleguide/chat-modal-thread-settings"] = Mod193;

export * as discourse$components$styleguide$chat__modal__thread__settings$$__module from "./discourse/components/styleguide/chat-modal-thread-settings";
export {
default as discourse$components$styleguide$chat__modal__thread__settings$$default
} from "./discourse/components/styleguide/chat-modal-thread-settings";
import * as Mod194 from "./discourse/components/styleguide/chat-modal-toggle-channel-status";
compatModules["discourse/components/styleguide/chat-modal-toggle-channel-status"] = Mod194;

export * as discourse$components$styleguide$chat__modal__toggle__channel__status$$__module from "./discourse/components/styleguide/chat-modal-toggle-channel-status";
export {
default as discourse$components$styleguide$chat__modal__toggle__channel__status$$default
} from "./discourse/components/styleguide/chat-modal-toggle-channel-status";
import * as Mod195 from "./discourse/components/styleguide/chat-thread-list-item";
compatModules["discourse/components/styleguide/chat-thread-list-item"] = Mod195;

export * as discourse$components$styleguide$chat__thread__list__item$$__module from "./discourse/components/styleguide/chat-thread-list-item";
export {
default as discourse$components$styleguide$chat__thread__list__item$$default
} from "./discourse/components/styleguide/chat-thread-list-item";
import * as Mod196 from "./discourse/components/styleguide/organisms/chat";
compatModules["discourse/components/styleguide/organisms/chat"] = Mod196;

export * as discourse$components$styleguide$organisms$chat$$__module from "./discourse/components/styleguide/organisms/chat";
export {
default as discourse$components$styleguide$organisms$chat$$default
} from "./discourse/components/styleguide/organisms/chat";
import * as Mod197 from "./discourse/components/svg/chat-zero";
compatModules["discourse/components/svg/chat-zero"] = Mod197;

export * as discourse$components$svg$chat__zero$$__module from "./discourse/components/svg/chat-zero";
export {
default as discourse$components$svg$chat__zero$$default
} from "./discourse/components/svg/chat-zero";
import * as Mod198 from "./discourse/components/thread-notifications-tracking";
compatModules["discourse/components/thread-notifications-tracking"] = Mod198;

export * as discourse$components$thread__notifications__tracking$$__module from "./discourse/components/thread-notifications-tracking";
export {
default as discourse$components$thread__notifications__tracking$$default
} from "./discourse/components/thread-notifications-tracking";
import * as Mod199 from "./discourse/components/thread-title/index";
compatModules["discourse/components/thread-title/index"] = Mod199;

export * as discourse$components$thread__title$index$$__module from "./discourse/components/thread-title/index";
export {
default as discourse$components$thread__title$index$$default,
default as discourse$components$thread__title$$default
} from "./discourse/components/thread-title/index";
import * as Mod200 from "./discourse/components/thread-unread-indicator/index";
compatModules["discourse/components/thread-unread-indicator/index"] = Mod200;

export * as discourse$components$thread__unread__indicator$index$$__module from "./discourse/components/thread-unread-indicator/index";
export {
default as discourse$components$thread__unread__indicator$index$$default,
default as discourse$components$thread__unread__indicator$$default
} from "./discourse/components/thread-unread-indicator/index";
import * as Mod201 from "./discourse/components/toggle-channel-membership-button";
compatModules["discourse/components/toggle-channel-membership-button"] = Mod201;

export * as discourse$components$toggle__channel__membership__button$$__module from "./discourse/components/toggle-channel-membership-button";
export {
default as discourse$components$toggle__channel__membership__button$$default
} from "./discourse/components/toggle-channel-membership-button";
import * as Mod202 from "./discourse/components/upsert-category/chat";
compatModules["discourse/components/upsert-category/chat"] = Mod202;

export * as discourse$components$upsert__category$chat$$__module from "./discourse/components/upsert-category/chat";
export {
default as discourse$components$upsert__category$chat$$default
} from "./discourse/components/upsert-category/chat";
import * as Mod203 from "./discourse/components/user-menu/chat-notifications-list-empty-state";
compatModules["discourse/components/user-menu/chat-notifications-list-empty-state"] = Mod203;

export * as discourse$components$user__menu$chat__notifications__list__empty__state$$__module from "./discourse/components/user-menu/chat-notifications-list-empty-state";
export {
default as discourse$components$user__menu$chat__notifications__list__empty__state$$default
} from "./discourse/components/user-menu/chat-notifications-list-empty-state";
import * as Mod204 from "./discourse/components/user-menu/chat-notifications-list";
compatModules["discourse/components/user-menu/chat-notifications-list"] = Mod204;

export * as discourse$components$user__menu$chat__notifications__list$$__module from "./discourse/components/user-menu/chat-notifications-list";
export {
default as discourse$components$user__menu$chat__notifications__list$$default
} from "./discourse/components/user-menu/chat-notifications-list";
import * as Mod205 from "./discourse/components/user-threads/index";
compatModules["discourse/components/user-threads/index"] = Mod205;

export * as discourse$components$user__threads$index$$__module from "./discourse/components/user-threads/index";
export {
default as discourse$components$user__threads$index$$default,
default as discourse$components$user__threads$$default
} from "./discourse/components/user-threads/index";
import * as Mod206 from "./discourse/components/user-threads/preview";
compatModules["discourse/components/user-threads/preview"] = Mod206;

export * as discourse$components$user__threads$preview$$__module from "./discourse/components/user-threads/preview";
export {
default as discourse$components$user__threads$preview$$default
} from "./discourse/components/user-threads/preview";
import * as Mod207 from "./discourse/connectors/above-site-header/chat-body-class.gjs";
compatModules["discourse/connectors/above-site-header/chat-body-class"] = Mod207;

export * as discourse$connectors$above__site__header$chat__body__class$$__module from "./discourse/connectors/above-site-header/chat-body-class.gjs";
export {
default as discourse$connectors$above__site__header$chat__body__class$$default
} from "./discourse/connectors/above-site-header/chat-body-class.gjs";
import * as Mod208 from "./discourse/connectors/below-footer/chat-drawer-outlet.gjs";
compatModules["discourse/connectors/below-footer/chat-drawer-outlet"] = Mod208;

export * as discourse$connectors$below__footer$chat__drawer__outlet$$__module from "./discourse/connectors/below-footer/chat-drawer-outlet.gjs";
export {
default as discourse$connectors$below__footer$chat__drawer__outlet$$default
} from "./discourse/connectors/below-footer/chat-drawer-outlet.gjs";
import * as Mod209 from "./discourse/connectors/below-footer/chat-message-actions-desktop-outlet.gjs";
compatModules["discourse/connectors/below-footer/chat-message-actions-desktop-outlet"] = Mod209;

export * as discourse$connectors$below__footer$chat__message__actions__desktop__outlet$$__module from "./discourse/connectors/below-footer/chat-message-actions-desktop-outlet.gjs";
export {
default as discourse$connectors$below__footer$chat__message__actions__desktop__outlet$$default
} from "./discourse/connectors/below-footer/chat-message-actions-desktop-outlet.gjs";
import * as Mod210 from "./discourse/connectors/chat-composer-inline-buttons/emoji-picker.gjs";
compatModules["discourse/connectors/chat-composer-inline-buttons/emoji-picker"] = Mod210;

export * as discourse$connectors$chat__composer__inline__buttons$emoji__picker$$__module from "./discourse/connectors/chat-composer-inline-buttons/emoji-picker.gjs";
export {
default as discourse$connectors$chat__composer__inline__buttons$emoji__picker$$default
} from "./discourse/connectors/chat-composer-inline-buttons/emoji-picker.gjs";
import * as Mod211 from "./discourse/connectors/home-logo-wrapper/chat-header-connector.gjs";
compatModules["discourse/connectors/home-logo-wrapper/chat-header-connector"] = Mod211;

export * as discourse$connectors$home__logo__wrapper$chat__header__connector$$__module from "./discourse/connectors/home-logo-wrapper/chat-header-connector.gjs";
export {
default as discourse$connectors$home__logo__wrapper$chat__header__connector$$default
} from "./discourse/connectors/home-logo-wrapper/chat-header-connector.gjs";
import * as Mod212 from "./discourse/connectors/user-card-below-message-button/chat-button.gjs";
compatModules["discourse/connectors/user-card-below-message-button/chat-button"] = Mod212;

export * as discourse$connectors$user__card__below__message__button$chat__button$$__module from "./discourse/connectors/user-card-below-message-button/chat-button.gjs";
export {
default as discourse$connectors$user__card__below__message__button$chat__button$$default
} from "./discourse/connectors/user-card-below-message-button/chat-button.gjs";
import * as Mod213 from "./discourse/connectors/user-preferences-emails-pref-email-settings/preferences-chat-emails.gjs";
compatModules["discourse/connectors/user-preferences-emails-pref-email-settings/preferences-chat-emails"] = Mod213;

export * as discourse$connectors$user__preferences__emails__pref__email__settings$preferences__chat__emails$$__module from "./discourse/connectors/user-preferences-emails-pref-email-settings/preferences-chat-emails.gjs";
export {
default as discourse$connectors$user__preferences__emails__pref__email__settings$preferences__chat__emails$$default
} from "./discourse/connectors/user-preferences-emails-pref-email-settings/preferences-chat-emails.gjs";
import * as Mod214 from "./discourse/connectors/user-preferences-nav/chat-preferences.gjs";
compatModules["discourse/connectors/user-preferences-nav/chat-preferences"] = Mod214;

export * as discourse$connectors$user__preferences__nav$chat__preferences$$__module from "./discourse/connectors/user-preferences-nav/chat-preferences.gjs";
export {
default as discourse$connectors$user__preferences__nav$chat__preferences$$default
} from "./discourse/connectors/user-preferences-nav/chat-preferences.gjs";
import * as Mod215 from "./discourse/connectors/user-profile-controls/chat-button.gjs";
compatModules["discourse/connectors/user-profile-controls/chat-button"] = Mod215;

export * as discourse$connectors$user__profile__controls$chat__button$$__module from "./discourse/connectors/user-profile-controls/chat-button.gjs";
export {
default as discourse$connectors$user__profile__controls$chat__button$$default
} from "./discourse/connectors/user-profile-controls/chat-button.gjs";
import * as Mod216 from "./discourse/controllers/chat-draft-channel";
compatModules["discourse/controllers/chat-draft-channel"] = Mod216;

export * as discourse$controllers$chat__draft__channel$$__module from "./discourse/controllers/chat-draft-channel";
export {
default as discourse$controllers$chat__draft__channel$$default
} from "./discourse/controllers/chat-draft-channel";
import * as Mod217 from "./discourse/controllers/chat";
compatModules["discourse/controllers/chat"] = Mod217;

export * as discourse$controllers$chat$$__module from "./discourse/controllers/chat";
export {
default as discourse$controllers$chat$$default
} from "./discourse/controllers/chat";
import * as Mod218 from "./discourse/controllers/chat/channel";
compatModules["discourse/controllers/chat/channel"] = Mod218;

export * as discourse$controllers$chat$channel$$__module from "./discourse/controllers/chat/channel";
export {
default as discourse$controllers$chat$channel$$default
} from "./discourse/controllers/chat/channel";
import * as Mod219 from "./discourse/controllers/chat/channel/index";
compatModules["discourse/controllers/chat/channel/index"] = Mod219;

export * as discourse$controllers$chat$channel$index$$__module from "./discourse/controllers/chat/channel/index";
export {
default as discourse$controllers$chat$channel$index$$default
} from "./discourse/controllers/chat/channel/index";
import * as Mod220 from "./discourse/controllers/chat/channel/thread";
compatModules["discourse/controllers/chat/channel/thread"] = Mod220;

export * as discourse$controllers$chat$channel$thread$$__module from "./discourse/controllers/chat/channel/thread";
export {
default as discourse$controllers$chat$channel$thread$$default
} from "./discourse/controllers/chat/channel/thread";
import * as Mod221 from "./discourse/controllers/chat/index";
compatModules["discourse/controllers/chat/index"] = Mod221;

export * as discourse$controllers$chat$index$$__module from "./discourse/controllers/chat/index";
export {
default as discourse$controllers$chat$index$$default
} from "./discourse/controllers/chat/index";
import * as Mod222 from "./discourse/controllers/chat/new-message";
compatModules["discourse/controllers/chat/new-message"] = Mod222;

export * as discourse$controllers$chat$new__message$$__module from "./discourse/controllers/chat/new-message";
export {
default as discourse$controllers$chat$new__message$$default
} from "./discourse/controllers/chat/new-message";
import * as Mod223 from "./discourse/helpers/chat-guardian";
compatModules["discourse/helpers/chat-guardian"] = Mod223;

export * as discourse$helpers$chat__guardian$$__module from "./discourse/helpers/chat-guardian";
export {
default as discourse$helpers$chat__guardian$$default
} from "./discourse/helpers/chat-guardian";
import * as Mod224 from "./discourse/helpers/first-visible-message-id";
compatModules["discourse/helpers/first-visible-message-id"] = Mod224;

export * as discourse$helpers$first__visible__message__id$$__module from "./discourse/helpers/first-visible-message-id";
export {
default as discourse$helpers$first__visible__message__id$$default
} from "./discourse/helpers/first-visible-message-id";
import * as Mod225 from "./discourse/helpers/format-chat-date";
compatModules["discourse/helpers/format-chat-date"] = Mod225;

export * as discourse$helpers$format__chat__date$$__module from "./discourse/helpers/format-chat-date";
export {
default as discourse$helpers$format__chat__date$$default
} from "./discourse/helpers/format-chat-date";
import * as Mod226 from "./discourse/initializers/chat-audio";
compatModules["discourse/initializers/chat-audio"] = Mod226;

export * as discourse$initializers$chat__audio$$__module from "./discourse/initializers/chat-audio";
export {
default as discourse$initializers$chat__audio$$default
} from "./discourse/initializers/chat-audio";
import * as Mod227 from "./discourse/initializers/chat-category-tab";
compatModules["discourse/initializers/chat-category-tab"] = Mod227;

export * as discourse$initializers$chat__category__tab$$__module from "./discourse/initializers/chat-category-tab";
export {
default as discourse$initializers$chat__category__tab$$default
} from "./discourse/initializers/chat-category-tab";
import * as Mod228 from "./discourse/initializers/chat-decorators";
compatModules["discourse/initializers/chat-decorators"] = Mod228;

export * as discourse$initializers$chat__decorators$$__module from "./discourse/initializers/chat-decorators";
export {
default as discourse$initializers$chat__decorators$$default
} from "./discourse/initializers/chat-decorators";
import * as Mod229 from "./discourse/initializers/chat-keyboard-shortcuts";
compatModules["discourse/initializers/chat-keyboard-shortcuts"] = Mod229;

export * as discourse$initializers$chat__keyboard__shortcuts$$__module from "./discourse/initializers/chat-keyboard-shortcuts";
export {
default as discourse$initializers$chat__keyboard__shortcuts$$default
} from "./discourse/initializers/chat-keyboard-shortcuts";
import * as Mod230 from "./discourse/initializers/chat-plugin-decorators";
compatModules["discourse/initializers/chat-plugin-decorators"] = Mod230;

export * as discourse$initializers$chat__plugin__decorators$$__module from "./discourse/initializers/chat-plugin-decorators";
export {
default as discourse$initializers$chat__plugin__decorators$$default
} from "./discourse/initializers/chat-plugin-decorators";
import * as Mod231 from "./discourse/initializers/chat-setup";
compatModules["discourse/initializers/chat-setup"] = Mod231;

export * as discourse$initializers$chat__setup$$__module from "./discourse/initializers/chat-setup";
export {
default as discourse$initializers$chat__setup$$default
} from "./discourse/initializers/chat-setup";
import * as Mod232 from "./discourse/initializers/chat-sidebar";
compatModules["discourse/initializers/chat-sidebar"] = Mod232;

export * as discourse$initializers$chat__sidebar$$__module from "./discourse/initializers/chat-sidebar";
export {
default as discourse$initializers$chat__sidebar$$default
} from "./discourse/initializers/chat-sidebar";
import * as Mod233 from "./discourse/initializers/chat-user-menu";
compatModules["discourse/initializers/chat-user-menu"] = Mod233;

export * as discourse$initializers$chat__user__menu$$__module from "./discourse/initializers/chat-user-menu";
export {
default as discourse$initializers$chat__user__menu$$default
} from "./discourse/initializers/chat-user-menu";
import * as Mod234 from "./discourse/initializers/chat-user-options";
compatModules["discourse/initializers/chat-user-options"] = Mod234;

export * as discourse$initializers$chat__user__options$$__module from "./discourse/initializers/chat-user-options";
export {
default as discourse$initializers$chat__user__options$$default
} from "./discourse/initializers/chat-user-options";
import * as Mod235 from "./discourse/lib/chat-channel-subscription-manager";
compatModules["discourse/lib/chat-channel-subscription-manager"] = Mod235;

export * as discourse$lib$chat__channel__subscription__manager$$__module from "./discourse/lib/chat-channel-subscription-manager";
export {
default as discourse$lib$chat__channel__subscription__manager$$default
} from "./discourse/lib/chat-channel-subscription-manager";
import * as Mod236 from "./discourse/lib/chat-channel-thread-subscription-manager";
compatModules["discourse/lib/chat-channel-thread-subscription-manager"] = Mod236;

export * as discourse$lib$chat__channel__thread__subscription__manager$$__module from "./discourse/lib/chat-channel-thread-subscription-manager";
export {
default as discourse$lib$chat__channel__thread__subscription__manager$$default
} from "./discourse/lib/chat-channel-thread-subscription-manager";
import * as Mod237 from "./discourse/lib/chat-composer-buttons";
compatModules["discourse/lib/chat-composer-buttons"] = Mod237;

export * as discourse$lib$chat__composer__buttons$$__module from "./discourse/lib/chat-composer-buttons";
export {
registerChatComposerButton as discourse$lib$chat__composer__buttons$$registerChatComposerButton,
chatComposerButtonsDependentKeys as discourse$lib$chat__composer__buttons$$chatComposerButtonsDependentKeys,
chatComposerButtons as discourse$lib$chat__composer__buttons$$chatComposerButtons,
clearChatComposerButtons as discourse$lib$chat__composer__buttons$$clearChatComposerButtons
} from "./discourse/lib/chat-composer-buttons";
import * as Mod238 from "./discourse/lib/chat-constants";
compatModules["discourse/lib/chat-constants"] = Mod238;

export * as discourse$lib$chat__constants$$__module from "./discourse/lib/chat-constants";
export {
PAST as discourse$lib$chat__constants$$PAST,
FUTURE as discourse$lib$chat__constants$$FUTURE,
READ_INTERVAL_MS as discourse$lib$chat__constants$$READ_INTERVAL_MS,
DEFAULT_MESSAGE_PAGE_SIZE as discourse$lib$chat__constants$$DEFAULT_MESSAGE_PAGE_SIZE,
THREAD_TITLE_PROMPT_THRESHOLD as discourse$lib$chat__constants$$THREAD_TITLE_PROMPT_THRESHOLD,
FOOTER_NAV_ROUTES as discourse$lib$chat__constants$$FOOTER_NAV_ROUTES,
INDICATOR_PREFERENCES as discourse$lib$chat__constants$$INDICATOR_PREFERENCES,
CHAT_ATTRS as discourse$lib$chat__constants$$CHAT_ATTRS,
CHAT_QUICK_REACTIONS_CUSTOM_DEFAULT as discourse$lib$chat__constants$$CHAT_QUICK_REACTIONS_CUSTOM_DEFAULT,
HEADER_INDICATOR_PREFERENCE_NEVER as discourse$lib$chat__constants$$HEADER_INDICATOR_PREFERENCE_NEVER,
HEADER_INDICATOR_PREFERENCE_DM_AND_MENTIONS as discourse$lib$chat__constants$$HEADER_INDICATOR_PREFERENCE_DM_AND_MENTIONS,
HEADER_INDICATOR_PREFERENCE_ALL_NEW as discourse$lib$chat__constants$$HEADER_INDICATOR_PREFERENCE_ALL_NEW,
HEADER_INDICATOR_PREFERENCE_ONLY_MENTIONS as discourse$lib$chat__constants$$HEADER_INDICATOR_PREFERENCE_ONLY_MENTIONS,
CHAT_SEND_SHORTCUT_ENTER as discourse$lib$chat__constants$$CHAT_SEND_SHORTCUT_ENTER,
CHAT_SEND_SHORTCUT_META_ENTER as discourse$lib$chat__constants$$CHAT_SEND_SHORTCUT_META_ENTER,
CHAT_QUICK_REACTION_TYPE_FREQUENT as discourse$lib$chat__constants$$CHAT_QUICK_REACTION_TYPE_FREQUENT,
CHAT_QUICK_REACTION_TYPE_CUSTOM as discourse$lib$chat__constants$$CHAT_QUICK_REACTION_TYPE_CUSTOM,
CHAT_SEPARATE_SIDEBAR_MODE_ALWAYS as discourse$lib$chat__constants$$CHAT_SEPARATE_SIDEBAR_MODE_ALWAYS,
CHAT_SEPARATE_SIDEBAR_MODE_FULLSCREEN as discourse$lib$chat__constants$$CHAT_SEPARATE_SIDEBAR_MODE_FULLSCREEN,
CHAT_SEPARATE_SIDEBAR_MODE_NEVER as discourse$lib$chat__constants$$CHAT_SEPARATE_SIDEBAR_MODE_NEVER,
MATCH_QUALITY_EXACT as discourse$lib$chat__constants$$MATCH_QUALITY_EXACT,
MATCH_QUALITY_PREFIX as discourse$lib$chat__constants$$MATCH_QUALITY_PREFIX,
MATCH_QUALITY_PARTIAL as discourse$lib$chat__constants$$MATCH_QUALITY_PARTIAL
} from "./discourse/lib/chat-constants";
import * as Mod239 from "./discourse/lib/chat-message-container";
compatModules["discourse/lib/chat-message-container"] = Mod239;

export * as discourse$lib$chat__message__container$$__module from "./discourse/lib/chat-message-container";
export {
MESSAGE_CONTEXT_PINNED as discourse$lib$chat__message__container$$MESSAGE_CONTEXT_PINNED,
default as discourse$lib$chat__message__container$$default
} from "./discourse/lib/chat-message-container";
import * as Mod240 from "./discourse/lib/chat-message-flag";
compatModules["discourse/lib/chat-message-flag"] = Mod240;

export * as discourse$lib$chat__message__flag$$__module from "./discourse/lib/chat-message-flag";
export {
default as discourse$lib$chat__message__flag$$default
} from "./discourse/lib/chat-message-flag";
import * as Mod241 from "./discourse/lib/chat-message-interactor";
compatModules["discourse/lib/chat-message-interactor"] = Mod241;

export * as discourse$lib$chat__message__interactor$$__module from "./discourse/lib/chat-message-interactor";
export {
removeChatComposerSecondaryActions as discourse$lib$chat__message__interactor$$removeChatComposerSecondaryActions,
resetRemovedChatComposerSecondaryActions as discourse$lib$chat__message__interactor$$resetRemovedChatComposerSecondaryActions,
default as discourse$lib$chat__message__interactor$$default
} from "./discourse/lib/chat-message-interactor";
import * as Mod242 from "./discourse/lib/chat-messages-loader";
compatModules["discourse/lib/chat-messages-loader"] = Mod242;

export * as discourse$lib$chat__messages__loader$$__module from "./discourse/lib/chat-messages-loader";
export {
default as discourse$lib$chat__messages__loader$$default
} from "./discourse/lib/chat-messages-loader";
import * as Mod243 from "./discourse/lib/chat-messages-manager";
compatModules["discourse/lib/chat-messages-manager"] = Mod243;

export * as discourse$lib$chat__messages__manager$$__module from "./discourse/lib/chat-messages-manager";
export {
default as discourse$lib$chat__messages__manager$$default
} from "./discourse/lib/chat-messages-manager";
import * as Mod244 from "./discourse/lib/chat-notification-levels";
compatModules["discourse/lib/chat-notification-levels"] = Mod244;

export * as discourse$lib$chat__notification__levels$$__module from "./discourse/lib/chat-notification-levels";
export {
threadNotificationButtonLevels as discourse$lib$chat__notification__levels$$threadNotificationButtonLevels
} from "./discourse/lib/chat-notification-levels";
import * as Mod245 from "./discourse/lib/chat-pane-state";
compatModules["discourse/lib/chat-pane-state"] = Mod245;

export * as discourse$lib$chat__pane__state$$__module from "./discourse/lib/chat-pane-state";
export {
default as discourse$lib$chat__pane__state$$default
} from "./discourse/lib/chat-pane-state";
import * as Mod246 from "./discourse/lib/chat-threads-manager";
compatModules["discourse/lib/chat-threads-manager"] = Mod246;

export * as discourse$lib$chat__threads__manager$$__module from "./discourse/lib/chat-threads-manager";
export {
default as discourse$lib$chat__threads__manager$$default
} from "./discourse/lib/chat-threads-manager";
import * as Mod247 from "./discourse/lib/chat-user-preferences";
compatModules["discourse/lib/chat-user-preferences"] = Mod247;

export * as discourse$lib$chat__user__preferences$$__module from "./discourse/lib/chat-user-preferences";
export {
hasChatIndicator as discourse$lib$chat__user__preferences$$hasChatIndicator
} from "./discourse/lib/chat-user-preferences";
import * as Mod248 from "./discourse/lib/check-message-visibility";
compatModules["discourse/lib/check-message-visibility"] = Mod248;

export * as discourse$lib$check__message__visibility$$__module from "./discourse/lib/check-message-visibility";
export {
checkMessageBottomVisibility as discourse$lib$check__message__visibility$$checkMessageBottomVisibility,
checkMessageTopVisibility as discourse$lib$check__message__visibility$$checkMessageTopVisibility
} from "./discourse/lib/check-message-visibility";
import * as Mod249 from "./discourse/lib/collection";
compatModules["discourse/lib/collection"] = Mod249;

export * as discourse$lib$collection$$__module from "./discourse/lib/collection";
export {
default as discourse$lib$collection$$default
} from "./discourse/lib/collection";
import * as Mod250 from "./discourse/lib/dates-separators-positioner";
compatModules["discourse/lib/dates-separators-positioner"] = Mod250;

export * as discourse$lib$dates__separators__positioner$$__module from "./discourse/lib/dates-separators-positioner";
export {
default as discourse$lib$dates__separators__positioner$$default
} from "./discourse/lib/dates-separators-positioner";
import * as Mod251 from "./discourse/lib/extract-current-topic-info";
compatModules["discourse/lib/extract-current-topic-info"] = Mod251;

export * as discourse$lib$extract__current__topic__info$$__module from "./discourse/lib/extract-current-topic-info";
export {
extractCurrentTopicInfo as discourse$lib$extract__current__topic__info$$extractCurrentTopicInfo
} from "./discourse/lib/extract-current-topic-info";
import * as Mod252 from "./discourse/lib/fabricators";
compatModules["discourse/lib/fabricators"] = Mod252;

export * as discourse$lib$fabricators$$__module from "./discourse/lib/fabricators";
export {
default as discourse$lib$fabricators$$default
} from "./discourse/lib/fabricators";
import * as Mod253 from "./discourse/lib/get-reaction-text";
compatModules["discourse/lib/get-reaction-text"] = Mod253;

export * as discourse$lib$get__reaction__text$$__module from "./discourse/lib/get-reaction-text";
export {
MAX_DISPLAYED_USERNAMES as discourse$lib$get__reaction__text$$MAX_DISPLAYED_USERNAMES,
getReactionText as discourse$lib$get__reaction__text$$getReactionText
} from "./discourse/lib/get-reaction-text";
import * as Mod254 from "./discourse/lib/get-user-chat-separate-sidebar-mode";
compatModules["discourse/lib/get-user-chat-separate-sidebar-mode"] = Mod254;

export * as discourse$lib$get__user__chat__separate__sidebar__mode$$__module from "./discourse/lib/get-user-chat-separate-sidebar-mode";
export {
getUserChatSeparateSidebarMode as discourse$lib$get__user__chat__separate__sidebar__mode$$getUserChatSeparateSidebarMode
} from "./discourse/lib/get-user-chat-separate-sidebar-mode";
import * as Mod255 from "./discourse/lib/gif-pick-handler";
compatModules["discourse/lib/gif-pick-handler"] = Mod255;

export * as discourse$lib$gif__pick__handler$$__module from "./discourse/lib/gif-pick-handler";
export {
buildGifPickHandler as discourse$lib$gif__pick__handler$$buildGifPickHandler
} from "./discourse/lib/gif-pick-handler";
import * as Mod256 from "./discourse/lib/hashtag-types/channel";
compatModules["discourse/lib/hashtag-types/channel"] = Mod256;

export * as discourse$lib$hashtag__types$channel$$__module from "./discourse/lib/hashtag-types/channel";
export {
default as discourse$lib$hashtag__types$channel$$default
} from "./discourse/lib/hashtag-types/channel";
import * as Mod257 from "./discourse/lib/init-sidebar-state";
compatModules["discourse/lib/init-sidebar-state"] = Mod257;

export * as discourse$lib$init__sidebar__state$$__module from "./discourse/lib/init-sidebar-state";
export {
CHAT_PANEL as discourse$lib$init__sidebar__state$$CHAT_PANEL,
initSidebarState as discourse$lib$init__sidebar__state$$initSidebarState
} from "./discourse/lib/init-sidebar-state";
import * as Mod258 from "./discourse/lib/scroll-helpers";
compatModules["discourse/lib/scroll-helpers"] = Mod258;

export * as discourse$lib$scroll__helpers$$__module from "./discourse/lib/scroll-helpers";
export {
maintainScrollPosition as discourse$lib$scroll__helpers$$maintainScrollPosition,
scrollListToBottom as discourse$lib$scroll__helpers$$scrollListToBottom,
scrollListToTop as discourse$lib$scroll__helpers$$scrollListToTop,
scrollListToMessage as discourse$lib$scroll__helpers$$scrollListToMessage
} from "./discourse/lib/scroll-helpers";
import * as Mod259 from "./discourse/lib/slugify-channel";
compatModules["discourse/lib/slugify-channel"] = Mod259;

export * as discourse$lib$slugify__channel$$__module from "./discourse/lib/slugify-channel";
export {
default as discourse$lib$slugify__channel$$default
} from "./discourse/lib/slugify-channel";
import * as Mod260 from "./discourse/lib/textarea-interactor";
compatModules["discourse/lib/textarea-interactor"] = Mod260;

export * as discourse$lib$textarea__interactor$$__module from "./discourse/lib/textarea-interactor";
export {
default as discourse$lib$textarea__interactor$$default
} from "./discourse/lib/textarea-interactor";
import * as Mod261 from "./discourse/lib/transform-auto-links";
compatModules["discourse/lib/transform-auto-links"] = Mod261;

export * as discourse$lib$transform__auto__links$$__module from "./discourse/lib/transform-auto-links";
export {
default as discourse$lib$transform__auto__links$$default
} from "./discourse/lib/transform-auto-links";
import * as Mod262 from "./discourse/models/chat-channel-archive";
compatModules["discourse/models/chat-channel-archive"] = Mod262;

export * as discourse$models$chat__channel__archive$$__module from "./discourse/models/chat-channel-archive";
export {
default as discourse$models$chat__channel__archive$$default
} from "./discourse/models/chat-channel-archive";
import * as Mod263 from "./discourse/models/chat-channel";
compatModules["discourse/models/chat-channel"] = Mod263;

export * as discourse$models$chat__channel$$__module from "./discourse/models/chat-channel";
export {
CHATABLE_TYPES as discourse$models$chat__channel$$CHATABLE_TYPES,
CHANNEL_STATUSES as discourse$models$chat__channel$$CHANNEL_STATUSES,
channelStatusIcon as discourse$models$chat__channel$$channelStatusIcon,
default as discourse$models$chat__channel$$default
} from "./discourse/models/chat-channel";
import * as Mod264 from "./discourse/models/chat-chatable";
compatModules["discourse/models/chat-chatable"] = Mod264;

export * as discourse$models$chat__chatable$$__module from "./discourse/models/chat-chatable";
export {
default as discourse$models$chat__chatable$$default
} from "./discourse/models/chat-chatable";
import * as Mod265 from "./discourse/models/chat-direct-message";
compatModules["discourse/models/chat-direct-message"] = Mod265;

export * as discourse$models$chat__direct__message$$__module from "./discourse/models/chat-direct-message";
export {
default as discourse$models$chat__direct__message$$default
} from "./discourse/models/chat-direct-message";
import * as Mod266 from "./discourse/models/chat-message-reaction";
compatModules["discourse/models/chat-message-reaction"] = Mod266;

export * as discourse$models$chat__message__reaction$$__module from "./discourse/models/chat-message-reaction";
export {
REACTIONS as discourse$models$chat__message__reaction$$REACTIONS,
default as discourse$models$chat__message__reaction$$default
} from "./discourse/models/chat-message-reaction";
import * as Mod267 from "./discourse/models/chat-message";
compatModules["discourse/models/chat-message"] = Mod267;

export * as discourse$models$chat__message$$__module from "./discourse/models/chat-message";
export {
default as discourse$models$chat__message$$default
} from "./discourse/models/chat-message";
import * as Mod268 from "./discourse/models/chat-notice";
compatModules["discourse/models/chat-notice"] = Mod268;

export * as discourse$models$chat__notice$$__module from "./discourse/models/chat-notice";
export {
default as discourse$models$chat__notice$$default
} from "./discourse/models/chat-notice";
import * as Mod269 from "./discourse/models/chat-thread-preview";
compatModules["discourse/models/chat-thread-preview"] = Mod269;

export * as discourse$models$chat__thread__preview$$__module from "./discourse/models/chat-thread-preview";
export {
default as discourse$models$chat__thread__preview$$default
} from "./discourse/models/chat-thread-preview";
import * as Mod270 from "./discourse/models/chat-thread";
compatModules["discourse/models/chat-thread"] = Mod270;

export * as discourse$models$chat__thread$$__module from "./discourse/models/chat-thread";
export {
THREAD_STATUSES as discourse$models$chat__thread$$THREAD_STATUSES,
default as discourse$models$chat__thread$$default
} from "./discourse/models/chat-thread";
import * as Mod271 from "./discourse/models/chat-tracking-state";
compatModules["discourse/models/chat-tracking-state"] = Mod271;

export * as discourse$models$chat__tracking__state$$__module from "./discourse/models/chat-tracking-state";
export {
default as discourse$models$chat__tracking__state$$default
} from "./discourse/models/chat-tracking-state";
import * as Mod272 from "./discourse/models/user-chat-channel-membership";
compatModules["discourse/models/user-chat-channel-membership"] = Mod272;

export * as discourse$models$user__chat__channel__membership$$__module from "./discourse/models/user-chat-channel-membership";
export {
default as discourse$models$user__chat__channel__membership$$default
} from "./discourse/models/user-chat-channel-membership";
import * as Mod273 from "./discourse/models/user-chat-thread-membership";
compatModules["discourse/models/user-chat-thread-membership"] = Mod273;

export * as discourse$models$user__chat__thread__membership$$__module from "./discourse/models/user-chat-thread-membership";
export {
default as discourse$models$user__chat__thread__membership$$default
} from "./discourse/models/user-chat-thread-membership";
import * as Mod274 from "./discourse/modifiers/chat/later-fn";
compatModules["discourse/modifiers/chat/later-fn"] = Mod274;

export * as discourse$modifiers$chat$later__fn$$__module from "./discourse/modifiers/chat/later-fn";
export {
default as discourse$modifiers$chat$later__fn$$default
} from "./discourse/modifiers/chat/later-fn";
import * as Mod275 from "./discourse/modifiers/chat/on-animation-end";
compatModules["discourse/modifiers/chat/on-animation-end"] = Mod275;

export * as discourse$modifiers$chat$on__animation__end$$__module from "./discourse/modifiers/chat/on-animation-end";
export {
default as discourse$modifiers$chat$on__animation__end$$default
} from "./discourse/modifiers/chat/on-animation-end";
import * as Mod276 from "./discourse/modifiers/chat/on-long-press";
compatModules["discourse/modifiers/chat/on-long-press"] = Mod276;

export * as discourse$modifiers$chat$on__long__press$$__module from "./discourse/modifiers/chat/on-long-press";
export {
default as discourse$modifiers$chat$on__long__press$$default
} from "./discourse/modifiers/chat/on-long-press";
import * as Mod277 from "./discourse/modifiers/chat/on-scroll";
compatModules["discourse/modifiers/chat/on-scroll"] = Mod277;

export * as discourse$modifiers$chat$on__scroll$$__module from "./discourse/modifiers/chat/on-scroll";
export {
default as discourse$modifiers$chat$on__scroll$$default
} from "./discourse/modifiers/chat/on-scroll";
import * as Mod278 from "./discourse/modifiers/chat/resizable-node";
compatModules["discourse/modifiers/chat/resizable-node"] = Mod278;

export * as discourse$modifiers$chat$resizable__node$$__module from "./discourse/modifiers/chat/resizable-node";
export {
default as discourse$modifiers$chat$resizable__node$$default
} from "./discourse/modifiers/chat/resizable-node";
import * as Mod279 from "./discourse/modifiers/chat/scrollable-list";
compatModules["discourse/modifiers/chat/scrollable-list"] = Mod279;

export * as discourse$modifiers$chat$scrollable__list$$__module from "./discourse/modifiers/chat/scrollable-list";
export {
default as discourse$modifiers$chat$scrollable__list$$default
} from "./discourse/modifiers/chat/scrollable-list";
import * as Mod280 from "./discourse/modifiers/chat/track-message-separator-date";
compatModules["discourse/modifiers/chat/track-message-separator-date"] = Mod280;

export * as discourse$modifiers$chat$track__message__separator__date$$__module from "./discourse/modifiers/chat/track-message-separator-date";
export {
default as discourse$modifiers$chat$track__message__separator__date$$default
} from "./discourse/modifiers/chat/track-message-separator-date";
import * as Mod281 from "./discourse/modifiers/chat/track-message";
compatModules["discourse/modifiers/chat/track-message"] = Mod281;

export * as discourse$modifiers$chat$track__message$$__module from "./discourse/modifiers/chat/track-message";
export {
default as discourse$modifiers$chat$track__message$$default
} from "./discourse/modifiers/chat/track-message";
import * as Mod282 from "./discourse/pre-initializers/chat-plugin-api";
compatModules["discourse/pre-initializers/chat-plugin-api"] = Mod282;

export * as discourse$pre__initializers$chat__plugin__api$$__module from "./discourse/pre-initializers/chat-plugin-api";
export {
default as discourse$pre__initializers$chat__plugin__api$$default
} from "./discourse/pre-initializers/chat-plugin-api";
import * as Mod283 from "./discourse/preferences-chat-route-map";
compatModules["discourse/preferences-chat-route-map"] = Mod283;

export * as discourse$preferences__chat__route__map$$__module from "./discourse/preferences-chat-route-map";
export {
default as discourse$preferences__chat__route__map$$default
} from "./discourse/preferences-chat-route-map";
import * as Mod284 from "./discourse/routes/chat-channel-decorator";
compatModules["discourse/routes/chat-channel-decorator"] = Mod284;

export * as discourse$routes$chat__channel__decorator$$__module from "./discourse/routes/chat-channel-decorator";
export {
default as discourse$routes$chat__channel__decorator$$default
} from "./discourse/routes/chat-channel-decorator";
import * as Mod285 from "./discourse/routes/chat-channel-legacy";
compatModules["discourse/routes/chat-channel-legacy"] = Mod285;

export * as discourse$routes$chat__channel__legacy$$__module from "./discourse/routes/chat-channel-legacy";
export {
default as discourse$routes$chat__channel__legacy$$default
} from "./discourse/routes/chat-channel-legacy";
import * as Mod286 from "./discourse/routes/chat-draft-channel";
compatModules["discourse/routes/chat-draft-channel"] = Mod286;

export * as discourse$routes$chat__draft__channel$$__module from "./discourse/routes/chat-draft-channel";
export {
default as discourse$routes$chat__draft__channel$$default
} from "./discourse/routes/chat-draft-channel";
import * as Mod287 from "./discourse/routes/chat";
compatModules["discourse/routes/chat"] = Mod287;

export * as discourse$routes$chat$$__module from "./discourse/routes/chat";
export {
default as discourse$routes$chat$$default
} from "./discourse/routes/chat";
import * as Mod288 from "./discourse/routes/chat/browse";
compatModules["discourse/routes/chat/browse"] = Mod288;

export * as discourse$routes$chat$browse$$__module from "./discourse/routes/chat/browse";
export {
default as discourse$routes$chat$browse$$default
} from "./discourse/routes/chat/browse";
import * as Mod289 from "./discourse/routes/chat/browse/archived";
compatModules["discourse/routes/chat/browse/archived"] = Mod289;

export * as discourse$routes$chat$browse$archived$$__module from "./discourse/routes/chat/browse/archived";
export {
default as discourse$routes$chat$browse$archived$$default
} from "./discourse/routes/chat/browse/archived";
import * as Mod290 from "./discourse/routes/chat/browse/index";
compatModules["discourse/routes/chat/browse/index"] = Mod290;

export * as discourse$routes$chat$browse$index$$__module from "./discourse/routes/chat/browse/index";
export {
default as discourse$routes$chat$browse$index$$default
} from "./discourse/routes/chat/browse/index";
import * as Mod291 from "./discourse/routes/chat/channel";
compatModules["discourse/routes/chat/channel"] = Mod291;

export * as discourse$routes$chat$channel$$__module from "./discourse/routes/chat/channel";
export {
default as discourse$routes$chat$channel$$default
} from "./discourse/routes/chat/channel";
import * as Mod292 from "./discourse/routes/chat/channel/info";
compatModules["discourse/routes/chat/channel/info"] = Mod292;

export * as discourse$routes$chat$channel$info$$__module from "./discourse/routes/chat/channel/info";
export {
default as discourse$routes$chat$channel$info$$default
} from "./discourse/routes/chat/channel/info";
import * as Mod293 from "./discourse/routes/chat/channel/info/index";
compatModules["discourse/routes/chat/channel/info/index"] = Mod293;

export * as discourse$routes$chat$channel$info$index$$__module from "./discourse/routes/chat/channel/info/index";
export {
default as discourse$routes$chat$channel$info$index$$default
} from "./discourse/routes/chat/channel/info/index";
import * as Mod294 from "./discourse/routes/chat/channel/info/members";
compatModules["discourse/routes/chat/channel/info/members"] = Mod294;

export * as discourse$routes$chat$channel$info$members$$__module from "./discourse/routes/chat/channel/info/members";
export {
default as discourse$routes$chat$channel$info$members$$default
} from "./discourse/routes/chat/channel/info/members";
import * as Mod295 from "./discourse/routes/chat/channel/info/search";
compatModules["discourse/routes/chat/channel/info/search"] = Mod295;

export * as discourse$routes$chat$channel$info$search$$__module from "./discourse/routes/chat/channel/info/search";
export {
default as discourse$routes$chat$channel$info$search$$default
} from "./discourse/routes/chat/channel/info/search";
import * as Mod296 from "./discourse/routes/chat/channel/near-message-with-thread";
compatModules["discourse/routes/chat/channel/near-message-with-thread"] = Mod296;

export * as discourse$routes$chat$channel$near__message__with__thread$$__module from "./discourse/routes/chat/channel/near-message-with-thread";
export {
default as discourse$routes$chat$channel$near__message__with__thread$$default
} from "./discourse/routes/chat/channel/near-message-with-thread";
import * as Mod297 from "./discourse/routes/chat/channel/near-message";
compatModules["discourse/routes/chat/channel/near-message"] = Mod297;

export * as discourse$routes$chat$channel$near__message$$__module from "./discourse/routes/chat/channel/near-message";
export {
default as discourse$routes$chat$channel$near__message$$default
} from "./discourse/routes/chat/channel/near-message";
import * as Mod298 from "./discourse/routes/chat/channel/pins";
compatModules["discourse/routes/chat/channel/pins"] = Mod298;

export * as discourse$routes$chat$channel$pins$$__module from "./discourse/routes/chat/channel/pins";
export {
default as discourse$routes$chat$channel$pins$$default
} from "./discourse/routes/chat/channel/pins";
import * as Mod299 from "./discourse/routes/chat/channel/thread";
compatModules["discourse/routes/chat/channel/thread"] = Mod299;

export * as discourse$routes$chat$channel$thread$$__module from "./discourse/routes/chat/channel/thread";
export {
default as discourse$routes$chat$channel$thread$$default
} from "./discourse/routes/chat/channel/thread";
import * as Mod300 from "./discourse/routes/chat/channel/thread/near-message";
compatModules["discourse/routes/chat/channel/thread/near-message"] = Mod300;

export * as discourse$routes$chat$channel$thread$near__message$$__module from "./discourse/routes/chat/channel/thread/near-message";
export {
default as discourse$routes$chat$channel$thread$near__message$$default
} from "./discourse/routes/chat/channel/thread/near-message";
import * as Mod301 from "./discourse/routes/chat/channel/threads";
compatModules["discourse/routes/chat/channel/threads"] = Mod301;

export * as discourse$routes$chat$channel$threads$$__module from "./discourse/routes/chat/channel/threads";
export {
default as discourse$routes$chat$channel$threads$$default
} from "./discourse/routes/chat/channel/threads";
import * as Mod302 from "./discourse/routes/chat/channels";
compatModules["discourse/routes/chat/channels"] = Mod302;

export * as discourse$routes$chat$channels$$__module from "./discourse/routes/chat/channels";
export {
default as discourse$routes$chat$channels$$default
} from "./discourse/routes/chat/channels";
import * as Mod303 from "./discourse/routes/chat/direct-messages";
compatModules["discourse/routes/chat/direct-messages"] = Mod303;

export * as discourse$routes$chat$direct__messages$$__module from "./discourse/routes/chat/direct-messages";
export {
default as discourse$routes$chat$direct__messages$$default
} from "./discourse/routes/chat/direct-messages";
import * as Mod304 from "./discourse/routes/chat/index";
compatModules["discourse/routes/chat/index"] = Mod304;

export * as discourse$routes$chat$index$$__module from "./discourse/routes/chat/index";
export {
default as discourse$routes$chat$index$$default
} from "./discourse/routes/chat/index";
import * as Mod305 from "./discourse/routes/chat/new-message";
compatModules["discourse/routes/chat/new-message"] = Mod305;

export * as discourse$routes$chat$new__message$$__module from "./discourse/routes/chat/new-message";
export {
default as discourse$routes$chat$new__message$$default
} from "./discourse/routes/chat/new-message";
import * as Mod306 from "./discourse/routes/chat/search";
compatModules["discourse/routes/chat/search"] = Mod306;

export * as discourse$routes$chat$search$$__module from "./discourse/routes/chat/search";
export {
default as discourse$routes$chat$search$$default
} from "./discourse/routes/chat/search";
import * as Mod307 from "./discourse/routes/chat/starred-channels";
compatModules["discourse/routes/chat/starred-channels"] = Mod307;

export * as discourse$routes$chat$starred__channels$$__module from "./discourse/routes/chat/starred-channels";
export {
default as discourse$routes$chat$starred__channels$$default
} from "./discourse/routes/chat/starred-channels";
import * as Mod308 from "./discourse/routes/chat/threads";
compatModules["discourse/routes/chat/threads"] = Mod308;

export * as discourse$routes$chat$threads$$__module from "./discourse/routes/chat/threads";
export {
default as discourse$routes$chat$threads$$default
} from "./discourse/routes/chat/threads";
import * as Mod309 from "./discourse/routes/preferences/chat";
compatModules["discourse/routes/preferences/chat"] = Mod309;

export * as discourse$routes$preferences$chat$$__module from "./discourse/routes/preferences/chat";
export {
default as discourse$routes$preferences$chat$$default
} from "./discourse/routes/preferences/chat";
import * as Mod310 from "./discourse/services/chat-admin-api";
compatModules["discourse/services/chat-admin-api"] = Mod310;

export * as discourse$services$chat__admin__api$$__module from "./discourse/services/chat-admin-api";
export {
default as discourse$services$chat__admin__api$$default
} from "./discourse/services/chat-admin-api";
import * as Mod311 from "./discourse/services/chat-api";
compatModules["discourse/services/chat-api"] = Mod311;

export * as discourse$services$chat__api$$__module from "./discourse/services/chat-api";
export {
default as discourse$services$chat__api$$default
} from "./discourse/services/chat-api";
import * as Mod312 from "./discourse/services/chat-audio-manager";
compatModules["discourse/services/chat-audio-manager"] = Mod312;

export * as discourse$services$chat__audio__manager$$__module from "./discourse/services/chat-audio-manager";
export {
CHAT_SOUNDS as discourse$services$chat__audio__manager$$CHAT_SOUNDS,
normalizeChatSoundName as discourse$services$chat__audio__manager$$normalizeChatSoundName,
default as discourse$services$chat__audio__manager$$default
} from "./discourse/services/chat-audio-manager";
import * as Mod313 from "./discourse/services/chat-channel-composer";
compatModules["discourse/services/chat-channel-composer"] = Mod313;

export * as discourse$services$chat__channel__composer$$__module from "./discourse/services/chat-channel-composer";
export {
default as discourse$services$chat__channel__composer$$default
} from "./discourse/services/chat-channel-composer";
import * as Mod314 from "./discourse/services/chat-channel-info-route-origin-manager";
compatModules["discourse/services/chat-channel-info-route-origin-manager"] = Mod314;

export * as discourse$services$chat__channel__info__route__origin__manager$$__module from "./discourse/services/chat-channel-info-route-origin-manager";
export {
BACK_KEY as discourse$services$chat__channel__info__route__origin__manager$$BACK_KEY,
INFO_ROUTE_NAMESPACE as discourse$services$chat__channel__info__route__origin__manager$$INFO_ROUTE_NAMESPACE,
ORIGINS as discourse$services$chat__channel__info__route__origin__manager$$ORIGINS,
default as discourse$services$chat__channel__info__route__origin__manager$$default
} from "./discourse/services/chat-channel-info-route-origin-manager";
import * as Mod315 from "./discourse/services/chat-channel-notices-manager";
compatModules["discourse/services/chat-channel-notices-manager"] = Mod315;

export * as discourse$services$chat__channel__notices__manager$$__module from "./discourse/services/chat-channel-notices-manager";
export {
default as discourse$services$chat__channel__notices__manager$$default
} from "./discourse/services/chat-channel-notices-manager";
import * as Mod316 from "./discourse/services/chat-channel-pane";
compatModules["discourse/services/chat-channel-pane"] = Mod316;

export * as discourse$services$chat__channel__pane$$__module from "./discourse/services/chat-channel-pane";
export {
default as discourse$services$chat__channel__pane$$default
} from "./discourse/services/chat-channel-pane";
import * as Mod317 from "./discourse/services/chat-channel-scroll-positions";
compatModules["discourse/services/chat-channel-scroll-positions"] = Mod317;

export * as discourse$services$chat__channel__scroll__positions$$__module from "./discourse/services/chat-channel-scroll-positions";
export {
default as discourse$services$chat__channel__scroll__positions$$default
} from "./discourse/services/chat-channel-scroll-positions";
import * as Mod318 from "./discourse/services/chat-channels-manager";
compatModules["discourse/services/chat-channels-manager"] = Mod318;

export * as discourse$services$chat__channels__manager$$__module from "./discourse/services/chat-channels-manager";
export {
default as discourse$services$chat__channels__manager$$default
} from "./discourse/services/chat-channels-manager";
import * as Mod319 from "./discourse/services/chat-composer-warnings-tracker";
compatModules["discourse/services/chat-composer-warnings-tracker"] = Mod319;

export * as discourse$services$chat__composer__warnings__tracker$$__module from "./discourse/services/chat-composer-warnings-tracker";
export {
default as discourse$services$chat__composer__warnings__tracker$$default
} from "./discourse/services/chat-composer-warnings-tracker";
import * as Mod320 from "./discourse/services/chat-drafts-manager";
compatModules["discourse/services/chat-drafts-manager"] = Mod320;

export * as discourse$services$chat__drafts__manager$$__module from "./discourse/services/chat-drafts-manager";
export {
default as discourse$services$chat__drafts__manager$$default
} from "./discourse/services/chat-drafts-manager";
import * as Mod321 from "./discourse/services/chat-drawer-router";
compatModules["discourse/services/chat-drawer-router"] = Mod321;

export * as discourse$services$chat__drawer__router$$__module from "./discourse/services/chat-drawer-router";
export {
default as discourse$services$chat__drawer__router$$default
} from "./discourse/services/chat-drawer-router";
import * as Mod322 from "./discourse/services/chat-drawer-size";
compatModules["discourse/services/chat-drawer-size"] = Mod322;

export * as discourse$services$chat__drawer__size$$__module from "./discourse/services/chat-drawer-size";
export {
default as discourse$services$chat__drawer__size$$default
} from "./discourse/services/chat-drawer-size";
import * as Mod323 from "./discourse/services/chat-guardian";
compatModules["discourse/services/chat-guardian"] = Mod323;

export * as discourse$services$chat__guardian$$__module from "./discourse/services/chat-guardian";
export {
default as discourse$services$chat__guardian$$default
} from "./discourse/services/chat-guardian";
import * as Mod324 from "./discourse/services/chat-history";
compatModules["discourse/services/chat-history"] = Mod324;

export * as discourse$services$chat__history$$__module from "./discourse/services/chat-history";
export {
default as discourse$services$chat__history$$default
} from "./discourse/services/chat-history";
import * as Mod325 from "./discourse/services/chat-notification-manager";
compatModules["discourse/services/chat-notification-manager"] = Mod325;

export * as discourse$services$chat__notification__manager$$__module from "./discourse/services/chat-notification-manager";
export {
default as discourse$services$chat__notification__manager$$default
} from "./discourse/services/chat-notification-manager";
import * as Mod326 from "./discourse/services/chat-pane-pending-manager";
compatModules["discourse/services/chat-pane-pending-manager"] = Mod326;

export * as discourse$services$chat__pane__pending__manager$$__module from "./discourse/services/chat-pane-pending-manager";
export {
default as discourse$services$chat__pane__pending__manager$$default
} from "./discourse/services/chat-pane-pending-manager";
import * as Mod327 from "./discourse/services/chat-search-query";
compatModules["discourse/services/chat-search-query"] = Mod327;

export * as discourse$services$chat__search__query$$__module from "./discourse/services/chat-search-query";
export {
default as discourse$services$chat__search__query$$default
} from "./discourse/services/chat-search-query";
import * as Mod328 from "./discourse/services/chat-state-manager";
compatModules["discourse/services/chat-state-manager"] = Mod328;

export * as discourse$services$chat__state__manager$$__module from "./discourse/services/chat-state-manager";
export {
addChatDrawerStateCallback as discourse$services$chat__state__manager$$addChatDrawerStateCallback,
resetChatDrawerStateCallbacks as discourse$services$chat__state__manager$$resetChatDrawerStateCallbacks,
default as discourse$services$chat__state__manager$$default
} from "./discourse/services/chat-state-manager";
import * as Mod329 from "./discourse/services/chat-subscriptions-manager";
compatModules["discourse/services/chat-subscriptions-manager"] = Mod329;

export * as discourse$services$chat__subscriptions__manager$$__module from "./discourse/services/chat-subscriptions-manager";
export {
default as discourse$services$chat__subscriptions__manager$$default
} from "./discourse/services/chat-subscriptions-manager";
import * as Mod330 from "./discourse/services/chat-thread-composer";
compatModules["discourse/services/chat-thread-composer"] = Mod330;

export * as discourse$services$chat__thread__composer$$__module from "./discourse/services/chat-thread-composer";
export {
default as discourse$services$chat__thread__composer$$default
} from "./discourse/services/chat-thread-composer";
import * as Mod331 from "./discourse/services/chat-thread-list-pane";
compatModules["discourse/services/chat-thread-list-pane"] = Mod331;

export * as discourse$services$chat__thread__list__pane$$__module from "./discourse/services/chat-thread-list-pane";
export {
default as discourse$services$chat__thread__list__pane$$default
} from "./discourse/services/chat-thread-list-pane";
import * as Mod332 from "./discourse/services/chat-thread-pane";
compatModules["discourse/services/chat-thread-pane"] = Mod332;

export * as discourse$services$chat__thread__pane$$__module from "./discourse/services/chat-thread-pane";
export {
default as discourse$services$chat__thread__pane$$default
} from "./discourse/services/chat-thread-pane";
import * as Mod333 from "./discourse/services/chat-tracking-state-manager";
compatModules["discourse/services/chat-tracking-state-manager"] = Mod333;

export * as discourse$services$chat__tracking__state__manager$$__module from "./discourse/services/chat-tracking-state-manager";
export {
default as discourse$services$chat__tracking__state__manager$$default
} from "./discourse/services/chat-tracking-state-manager";
import * as Mod334 from "./discourse/services/chat";
compatModules["discourse/services/chat"] = Mod334;

export * as discourse$services$chat$$__module from "./discourse/services/chat";
export {
default as discourse$services$chat$$default
} from "./discourse/services/chat";
import * as Mod335 from "./discourse/services/interacted-chat-message";
compatModules["discourse/services/interacted-chat-message"] = Mod335;

export * as discourse$services$interacted__chat__message$$__module from "./discourse/services/interacted-chat-message";
export {
default as discourse$services$interacted__chat__message$$default
} from "./discourse/services/interacted-chat-message";
import * as Mod336 from "./discourse/templates/chat";
compatModules["discourse/templates/chat"] = Mod336;

export * as discourse$templates$chat$$__module from "./discourse/templates/chat";
export {
default as discourse$templates$chat$$default
} from "./discourse/templates/chat";
import * as Mod337 from "./discourse/templates/chat/browse";
compatModules["discourse/templates/chat/browse"] = Mod337;

export * as discourse$templates$chat$browse$$__module from "./discourse/templates/chat/browse";
export {
default as discourse$templates$chat$browse$$default
} from "./discourse/templates/chat/browse";
import * as Mod338 from "./discourse/templates/chat/browse/all";
compatModules["discourse/templates/chat/browse/all"] = Mod338;

export * as discourse$templates$chat$browse$all$$__module from "./discourse/templates/chat/browse/all";
export {
default as discourse$templates$chat$browse$all$$default
} from "./discourse/templates/chat/browse/all";
import * as Mod339 from "./discourse/templates/chat/browse/archived";
compatModules["discourse/templates/chat/browse/archived"] = Mod339;

export * as discourse$templates$chat$browse$archived$$__module from "./discourse/templates/chat/browse/archived";
export {
default as discourse$templates$chat$browse$archived$$default
} from "./discourse/templates/chat/browse/archived";
import * as Mod340 from "./discourse/templates/chat/browse/closed";
compatModules["discourse/templates/chat/browse/closed"] = Mod340;

export * as discourse$templates$chat$browse$closed$$__module from "./discourse/templates/chat/browse/closed";
export {
default as discourse$templates$chat$browse$closed$$default
} from "./discourse/templates/chat/browse/closed";
import * as Mod341 from "./discourse/templates/chat/browse/open";
compatModules["discourse/templates/chat/browse/open"] = Mod341;

export * as discourse$templates$chat$browse$open$$__module from "./discourse/templates/chat/browse/open";
export {
default as discourse$templates$chat$browse$open$$default
} from "./discourse/templates/chat/browse/open";
import * as Mod342 from "./discourse/templates/chat/channel";
compatModules["discourse/templates/chat/channel"] = Mod342;

export * as discourse$templates$chat$channel$$__module from "./discourse/templates/chat/channel";
export {
default as discourse$templates$chat$channel$$default
} from "./discourse/templates/chat/channel";
import * as Mod343 from "./discourse/templates/chat/channel/info";
compatModules["discourse/templates/chat/channel/info"] = Mod343;

export * as discourse$templates$chat$channel$info$$__module from "./discourse/templates/chat/channel/info";
export {
default as discourse$templates$chat$channel$info$$default
} from "./discourse/templates/chat/channel/info";
import * as Mod344 from "./discourse/templates/chat/channel/info/members";
compatModules["discourse/templates/chat/channel/info/members"] = Mod344;

export * as discourse$templates$chat$channel$info$members$$__module from "./discourse/templates/chat/channel/info/members";
export {
default as discourse$templates$chat$channel$info$members$$default
} from "./discourse/templates/chat/channel/info/members";
import * as Mod345 from "./discourse/templates/chat/channel/info/settings";
compatModules["discourse/templates/chat/channel/info/settings"] = Mod345;

export * as discourse$templates$chat$channel$info$settings$$__module from "./discourse/templates/chat/channel/info/settings";
export {
default as discourse$templates$chat$channel$info$settings$$default
} from "./discourse/templates/chat/channel/info/settings";
import * as Mod346 from "./discourse/templates/chat/channel/pins";
compatModules["discourse/templates/chat/channel/pins"] = Mod346;

export * as discourse$templates$chat$channel$pins$$__module from "./discourse/templates/chat/channel/pins";
export {
default as discourse$templates$chat$channel$pins$$default
} from "./discourse/templates/chat/channel/pins";
import * as Mod347 from "./discourse/templates/chat/channel/thread";
compatModules["discourse/templates/chat/channel/thread"] = Mod347;

export * as discourse$templates$chat$channel$thread$$__module from "./discourse/templates/chat/channel/thread";
export {
default as discourse$templates$chat$channel$thread$$default
} from "./discourse/templates/chat/channel/thread";
import * as Mod348 from "./discourse/templates/chat/channel/threads";
compatModules["discourse/templates/chat/channel/threads"] = Mod348;

export * as discourse$templates$chat$channel$threads$$__module from "./discourse/templates/chat/channel/threads";
export {
default as discourse$templates$chat$channel$threads$$default
} from "./discourse/templates/chat/channel/threads";
import * as Mod349 from "./discourse/templates/chat/channels";
compatModules["discourse/templates/chat/channels"] = Mod349;

export * as discourse$templates$chat$channels$$__module from "./discourse/templates/chat/channels";
export {
default as discourse$templates$chat$channels$$default
} from "./discourse/templates/chat/channels";
import * as Mod350 from "./discourse/templates/chat/direct-messages";
compatModules["discourse/templates/chat/direct-messages"] = Mod350;

export * as discourse$templates$chat$direct__messages$$__module from "./discourse/templates/chat/direct-messages";
export {
default as discourse$templates$chat$direct__messages$$default
} from "./discourse/templates/chat/direct-messages";
import * as Mod351 from "./discourse/templates/chat/index";
compatModules["discourse/templates/chat/index"] = Mod351;

export * as discourse$templates$chat$index$$__module from "./discourse/templates/chat/index";
export {
default as discourse$templates$chat$index$$default
} from "./discourse/templates/chat/index";
import * as Mod352 from "./discourse/templates/chat/search";
compatModules["discourse/templates/chat/search"] = Mod352;

export * as discourse$templates$chat$search$$__module from "./discourse/templates/chat/search";
export {
default as discourse$templates$chat$search$$default
} from "./discourse/templates/chat/search";
import * as Mod353 from "./discourse/templates/chat/starred-channels";
compatModules["discourse/templates/chat/starred-channels"] = Mod353;

export * as discourse$templates$chat$starred__channels$$__module from "./discourse/templates/chat/starred-channels";
export {
default as discourse$templates$chat$starred__channels$$default
} from "./discourse/templates/chat/starred-channels";
import * as Mod354 from "./discourse/templates/chat/threads";
compatModules["discourse/templates/chat/threads"] = Mod354;

export * as discourse$templates$chat$threads$$__module from "./discourse/templates/chat/threads";
export {
default as discourse$templates$chat$threads$$default
} from "./discourse/templates/chat/threads";
import * as Mod355 from "./discourse/templates/preferences/chat";
compatModules["discourse/templates/preferences/chat"] = Mod355;

export * as discourse$templates$preferences$chat$$__module from "./discourse/templates/preferences/chat";
export {
default as discourse$templates$preferences$chat$$default
} from "./discourse/templates/preferences/chat";
import * as Mod356 from "./lib/discourse-markdown/chat-html-inline";
compatModules["lib/discourse-markdown/chat-html-inline"] = Mod356;

export * as lib$discourse__markdown$chat__html__inline$$__module from "./lib/discourse-markdown/chat-html-inline";
export {
setup as lib$discourse__markdown$chat__html__inline$$setup
} from "./lib/discourse-markdown/chat-html-inline";
import * as Mod357 from "./lib/discourse-markdown/chat-transcript";
compatModules["lib/discourse-markdown/chat-transcript"] = Mod357;

export * as lib$discourse__markdown$chat__transcript$$__module from "./lib/discourse-markdown/chat-transcript";
export {
setup as lib$discourse__markdown$chat__transcript$$setup
} from "./lib/discourse-markdown/chat-transcript";
import * as Mod358 from "./lib/rich-editor-extension";
compatModules["lib/rich-editor-extension"] = Mod358;

export * as lib$rich__editor__extension$$__module from "./lib/rich-editor-extension";
export {
default as lib$rich__editor__extension$$default
} from "./lib/rich-editor-extension";
export default compatModules;
